
if (localStorage.getItem('currency')) {
  var dcurrency = localStorage.getItem('currency');
} else {
  dcurrency = 'USD';
}
if (localStorage.getItem('currency-symbole')) {
  var currencysymbole = localStorage.getItem('currency-symbole');
} else {
  currencysymbole = "$";
}

var apiUrl = "https://api.cryptolyse.com/";
// var apiUrl = "/testapi.txt";

   $(document).ready(function() {

     jQuery.fn.dataTableExt.oSort['numeric-val-asc']  = function(a,b) {
      var ainit = $(a).attr("data-val");
      var binit = $(b).attr("data-val");

      var x = (ainit == "N/A") ? 99999999 : ainit.replace( /,/, "." );
      var y = (binit == "N/A") ? 99999999 : binit.replace( /,/, "." );

      x = parseFloat( x );
      y = parseFloat( y );
      return ((x < y) ? -1 : ((x > y) ?  1 : 0));
     };

     jQuery.fn.dataTableExt.oSort['numeric-val-desc'] = function(a,b) {
      var ainit = $(a).attr("data-val");
      var binit = $(b).attr("data-val");

      var x = (ainit == "N/A") ? -99999999 : ainit.replace( /,/, "." );
      var y = (binit == "N/A") ? -99999999 : binit.replace( /,/, "." );

      x = parseFloat( x );
      y = parseFloat( y );
      return ((x < y) ?  1 : ((x > y) ? -1 : 0));
     };


        btcPrice = 0;
        ethPrice = 0;

       function getBtcEth() {
        $.getJSON(apiUrl, function(data) {

             btcPrice = data[0][dcurrency]["current_price"]
             ethPrice = data[1][dcurrency]["current_price"]

         });
       }
      //
      getBtcEth();
      setInterval(getBtcEth, 5000);




      lsLang = localStorage.language;

      if (lsLang == "en") {
        trans_Name = "Name";
        trans_price = "Price";
        trans_Price_in = "Price in";
        trans_age = "Age";
        trans_Volume24h = "Volume 24h";
        trans_CirculatingSupply = "Circulating Supply";
        trans_MarketCap = "Market Cap";
      }

      if (lsLang == "de") {
        trans_Name = "Name";
        trans_price = "Preis";
        trans_Price_in = "Preis in";
        trans_age = "Alter";
        trans_Volume24h = "Volumen 24h";
        trans_CirculatingSupply = "Umlaufversorgung";
        trans_MarketCap = "Marktkapitalisierung";
      }

      if (lsLang == "fr") {
        trans_Name = "Nom";
        trans_price = "Prix";
        trans_Price_in = "Prix en";
        trans_age = "Age";
        trans_Volume24h = "Volume 24h";
        trans_CirculatingSupply = "Offre en circulation";
        trans_MarketCap = "Cap. Marché";
      }


     var  JSTable =  $('#crypto-table').DataTable( {
             // data: data,
             ajax: {
             url: apiUrl,
             dataSrc: '',
             },
             deferRender: true,
             // processing: true,
             // serverSide: false,
              // select: {
              //     style: 'multi',
              //     selector: 'td:first-child label'
              // },
             dom: 'Bfrtip',
             rowId: 'USD.symbol',
             stateSave: true,
             stateDuration: 0,
             fixedHeader: false,
             paging: true,
             pageLength: 25,
             lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
             language: {
               "paginate": {
                  "next": "›",
                  "previous": "‹"
                }
               },
             // autoWidth: false,
             // responsive: false,
              buttons: [ {
                extend: 'columnsToggle',
                columns: '.visibility'
              }
             ],
              // dom: 'Bfrtip',
              // colReorder: { fixedColumnsRight: 1, fixedColumnsLeft: 4 },
              colReorder: { fixedColumnsLeft: 3 },
               order: [[ 1, "asc" ]],


              columns: [

                 {title:"<span>&nbsp;</span>", targets: 0,className:"watch", width: "2%", data: function (row) {
                         return '<div class="watchlist-star-group"><label data-hover-text="watchlist">  <svg xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 -10 511.98685 511" width="15"><path d="m510.652344 185.902344c-3.351563-10.367188-12.546875-17.730469-23.425782-18.710938l-147.773437-13.417968-58.433594-136.769532c-4.308593-10.023437-14.121093-16.511718-25.023437-16.511718s-20.714844 6.488281-25.023438 16.535156l-58.433594 136.746094-147.796874 13.417968c-10.859376 1.003906-20.03125 8.34375-23.402344 18.710938-3.371094 10.367187-.257813 21.738281 7.957031 28.90625l111.699219 97.960937-32.9375 145.089844c-2.410156 10.667969 1.730468 21.695313 10.582031 28.09375 4.757813 3.4375 10.324219 5.1875 15.9375 5.1875 4.839844 0 9.640625-1.304687 13.949219-3.882813l127.46875-76.183593 127.421875 76.183593c9.324219 5.609376 21.078125 5.097657 29.910156-1.304687 8.855469-6.417969 12.992187-17.449219 10.582031-28.09375l-32.9375-145.089844 111.699219-97.941406c8.214844-7.1875 11.351563-18.539063 7.980469-28.925781zm0 0" fill="transparent" id="heart-path" stroke="rgb(126, 136, 155)" stroke-width="40" marker="none" visibility="visible" display="inline" overflow="visible"></path></svg></label></div>';
                       }},

                 {title:"<span>#</span>",width: "3%", className:"number", name:"number", targets: 1, data: function (row) {
                         return row[dcurrency]["market_cap_rank"];
                       }},

                 {title:"<span>"+trans_Name+"</span>", width: "15%", targets: 2, className:"name", data: function (row) {
                         twitterInit = row["USD"]["links"]["twitter"].replace(/^.*\/\/[^\/]+/, '').substring(1)

                         if (row[dcurrency]['symbol'] != "KLV") {
                            imgSrc  = row[dcurrency]['image']
                         } else {
                           imgSrc = "../assets/static/klv.png";
                         }

                         coinDesc = row["USD"]["description"].replaceAll("'","_apstrph");

                         return "<a href='/?coin="+row[dcurrency]['symbol'].toUpperCase().replace(/_/g,"")+"' data-key='"+row['USD']['key']+"' data-desc='"+coinDesc+"' data-wp='"+row['USD']['links']['whitepaper_pdf']+"' data-twitter='"+twitterInit+"'  class='title-modal'><span class='chartsvg chartsvgL'><img style='border-radius:4px' width='30' height='30' alt='"+row[dcurrency]['name']+"' src='"+imgSrc+"'></span><span class='ctitle'><h3 class='name'>"+row[dcurrency]['name']+"</h3><span class='h6'>"+row[dcurrency]['symbol'].toUpperCase().replace(/_/g,"")+"</span><span class='ctnumber hide'>#"+row[dcurrency]['market_cap_rank']+"</span></span></a>";
                       }},

                 {title:"<span>"+trans_price+"</span>", width: "11%", targets: 3, className:"price", data: function (row) {




                      elemSize = "";
                      priceBeh = "";
                      oldPriceEl = $('#price'+row[dcurrency]["symbol"].toUpperCase()+'l').html();


                      if (oldPriceEl) {
                        newCurrency = oldPriceEl.slice(-1);
                        if (currencysymbole == newCurrency) {
                         oldPrice = parseFloat(oldPriceEl.replace(/[^0-9\.]+/g, ""));
                         if (row[dcurrency]["current_price"] < oldPrice) {
                           priceBeh = "price_fall";
                         } else if (row[dcurrency]["current_price"] == oldPrice) {
                           priceBeh = "";
                         } else {
                           priceBeh = "price_rise";
                         }
                        }
                       }

                       if (row[dcurrency]["current_price"] > 20000) {
                        newPrice = currency(row[dcurrency]["current_price"],{ precision: 0, symbol: '', separator: ',' }).format();
                      } else if (row[dcurrency]["current_price"] > 1000) {
                        newPrice = currency(row[dcurrency]["current_price"],{ precision: 2, symbol: '', separator: ',' }).format();
                      } else if (row[dcurrency]["current_price"] > 0.00001) {
                        newPrice = row[dcurrency]["current_price"];
                      } else {
                        newPrice = convert(row[dcurrency]["current_price"]);
                        elemSize = "smallsize"
                      }







                         return '<span id="price'+row[dcurrency]["symbol"].toUpperCase()+'l" class="price '+elemSize+' '+priceBeh+'">'+newPrice+' '+currencysymbole+'</span>';
                       }},





                       {title:"<span>RSI <curr>$</curr></span>", width: "9%",targets: 4, className:"rsi",name:"rsi", data: function (row) {



                         rsiBeh = "";
                         oldRsiEl = $('#rsi'+row[dcurrency]["symbol"].toUpperCase()+'l').html();
                         if ((oldRsiEl) && (row["USD"]["rsi"] !== "NA")) {
                            oldRsi = parseFloat(oldRsiEl.replace(/[^0-9\.]+/g, ""));

                            // console.log(oldRsi, ' - ', row["USD"]["rsi"] );

                            if (parseFloat(row["USD"]["rsi"]).toFixed(2) < oldRsi) {
                              rsiBeh = " price_fall";
                            } else if (parseFloat(row["USD"]["rsi"]).toFixed(2) == oldRsi) {
                              rsiBeh = "";
                            } else {
                              rsiBeh = " price_rise";
                            }

                          }



                         if ((row["USD"]["rsi"] == "NA") || (row["USD"]["rsi"] == "undefined") || (row["USD"]["rsi"] == "1e+100")) {
                           rsiVal = "N/A";
                         } else {
                           rsiVal = parseFloat(row["USD"]["rsi"]).toFixed(2);
                         }


                         coin = row[dcurrency]["symbol"].toUpperCase();



                           colorRsi = '';
                           backgroundRsi = '';
                           if (row["USD"]["rsi"]) {

                             if (rsiVal < 10) {
                               colorRsi = 'color: #ffffff';
                               backgroundRsi = 'rgb(38, 166, 154,.85)';
                             } else if (rsiVal < 20) {
                               colorRsi = 'color: #ffffff';
                               backgroundRsi = 'rgb(38, 166, 154,.65)';
                             } else if (rsiVal < 30) {
                               backgroundRsi = 'rgb(38, 166, 154,.45)';
                             } else if (rsiVal < 40) {
                               backgroundRsi = 'rgb(38, 166, 154,.25)';
                             } else if (rsiVal < 45) {
                               backgroundRsi = 'rgb(38, 166, 154,.1)';
                             } else if (rsiVal < 50) {
                               backgroundRsi = 'rgb(38, 166, 154,.05)';
                             }  else if (rsiVal < 55) {
                               backgroundRsi = 'rgb(244, 67, 54,.1)';
                             }  else if (rsiVal < 60) {
                               backgroundRsi = 'rgb(244, 67, 54,.2)';
                             } else if (rsiVal < 70) {
                               backgroundRsi = 'rgb(244, 67, 54,.45)';
                             } else if (rsiVal < 80) {
                               colorRsi = 'color: #ffffff';
                               backgroundRsi = 'rgb(244, 67, 54,.65)';
                             } else if (rsiVal < 90) {
                               colorRsi = 'color: #ffffff';
                               backgroundRsi = 'rgb(244, 67, 54,.85)';
                             } else if (rsiVal <= 100) {
                               colorRsi = 'color: #ffffff';
                               backgroundRsi = 'rgb(244, 67, 54,.98)';
                             }

                          } else {
                            backgroundRsi = 'rgb(38, 166, 154,.05)';
                          }





                               return '<span id="rsi'+row[dcurrency]["symbol"].toUpperCase()+'l" data-val="'+rsiVal+'" style="'+colorRsi+';background:'+backgroundRsi+'" class="rsi'+rsiBeh+'">'+rsiVal+'</span>';





                             }},



                             {title:"<span>BB:Lower <curr>$</curr></span>", width: "9%",targets: 5, visible: false,className:"boll lw", data: function (row) {

                               if (row["USD"]["boll_lower"] == "NA") {
                                 BollLwPer = "N/A";
                               } else {
                                 BollLwPer =  -(1 - row["USD"]["current_price"]/row["USD"]["boll_lower"])*100;
                               }


                                  if (BollLwPer < 0) {
                                    changeVal = "negChange";
                                  } else {
                                    changeVal = "posChange";
                                  }

                                  bollLBeh = "";
                                  elemSize = "";


                                  if ((row["USD"]["boll_lower"] == "NA") || (!row["USD"]["boll_lower"])) {
                                    newboll_lower = "N/A";
                                  } else {
                                      if (convert(row["USD"]["boll_lower"]) > 20000) {
                                       newboll_lower = currency(row["USD"]["boll_lower"],{ precision: 0, symbol: '', separator: ',' }).format();
                                     } else if (convert(row["USD"]["boll_lower"]) > 1000) {
                                       newboll_lower = currency(row["USD"]["boll_lower"],{ precision: 2, symbol: '', separator: ',' }).format();
                                     } else if (convert(row["USD"]["boll_lower"]) > 0.01) {
                                       newboll_lower = parseFloat(convert(row["USD"]["boll_lower"])).toFixed(4);
                                     } else if (convert(row["USD"]["boll_lower"]) > 0.000001) {
                                       newboll_lower = parseFloat(convert(row["USD"]["boll_lower"])).toFixed(8);
                                     } else {
                                       newboll_lower = parseFloat(convert(row["USD"]["boll_lower"])).toFixed(12);
                                       elemSize = "smallsize";
                                     }
                                     newboll_lower += ' $';
                                   }


                                 if ($('#boll_lowerchange'+row["USD"]["symbol"].toUpperCase()+'l').html()) {

                                  oldBollLEl = $('#boll_lowerchange'+row["USD"]["symbol"].toUpperCase()+'l').attr("data-boll_lower");
                                  if (oldBollLEl) {
                                     oldBollL = parseFloat(oldBollLEl.replace(/[^0-9\.]+/g, ""));
                                     newboll_lowerEl = parseFloat(newboll_lower.replace(/[^0-9\.]+/g, ""));

                                     if (oldBollLEl !== "N/A") {
                                       if (newboll_lowerEl < oldBollL) {
                                         bollLBeh = "price_fall";
                                       } else if (newboll_lowerEl == oldBollL) {
                                         bollLBeh = "";
                                       } else {
                                         bollLBeh = "price_rise";
                                       }
                                    }


                                   }
                                 }


                                 if (BollLwPer !== "N/A") {
                                   BollLwPerVal = parseFloat(BollLwPer).toFixed(2)
                                 } else {
                                   BollLwPerVal = "N/A";
                                 }



                                  return '<span data-boll_lower="'+newboll_lower+'" data-val="'+BollLwPerVal+'" id="boll_lowerchange'+row["USD"]["symbol"].toUpperCase()+'l" class="pchangeboll_lower doubleVal '+elemSize+' '+bollLBeh+' '+changeVal+'">'+BollLwPerVal+'%</span>';

                                   }},


                             {title:"<span>BB:Basis <curr>$</curr></span>", width: "9%",targets: 6, className:"boll bs", data: function (row) {

                               if (row["USD"]["boll_basis"] == "NA") {
                                 BollBsPer = "N/A";
                               } else {
                                 BollBsPer =  -(1 - row["USD"]["current_price"]/row["USD"]["boll_basis"])*100;
                               }


                                  if (BollBsPer < 0) {
                                    changeVal = "negChange";
                                  } else {
                                    changeVal = "posChange";
                                  }

                                  bollBBeh = "";
                                  elemSize = "";


                                  if ((row["USD"]["boll_basis"] == "NA") || (!row["USD"]["boll_basis"])) {
                                    newboll_basis = "N/A";
                                  } else {
                                      if (convert(row["USD"]["boll_basis"]) > 20000) {
                                       newboll_basis = currency(row["USD"]["boll_basis"],{ precision: 0, symbol: '', separator: ',' }).format();
                                     } else if (convert(row["USD"]["boll_basis"]) > 1000) {
                                       newboll_basis = currency(row["USD"]["boll_basis"],{ precision: 2, symbol: '', separator: ',' }).format();
                                     } else if (convert(row["USD"]["boll_basis"]) > 0.01) {
                                       newboll_basis = parseFloat(convert(row["USD"]["boll_basis"])).toFixed(4);
                                     } else if (convert(row["USD"]["boll_basis"]) > 0.000001) {
                                       newboll_basis = parseFloat(convert(row["USD"]["boll_basis"])).toFixed(8);
                                     } else {
                                       newboll_basis = parseFloat(convert(row["USD"]["boll_basis"])).toFixed(12);
                                       elemSize = "smallsize";
                                     }
                                     newboll_basis += ' $';
                                   }


                                 if ($('#boll_basischange'+row["USD"]["symbol"].toUpperCase()+'l').html()) {

                                  oldBollBEl = $('#boll_basischange'+row["USD"]["symbol"].toUpperCase()+'l').attr("data-boll_basis");
                                  if (oldBollBEl) {
                                     oldBollB = parseFloat(oldBollBEl.replace(/[^0-9\.]+/g, ""));
                                     newboll_basisEl = parseFloat(newboll_basis.replace(/[^0-9\.]+/g, ""));
                                    if (oldBollBEl !== "N/A") {
                                     if (newboll_basisEl < oldBollB) {
                                       bollBBeh = "price_fall";
                                     } else if (newboll_basisEl == oldBollB) {
                                       bollBBeh = "";
                                     } else {
                                       bollBBeh = "price_rise";
                                     }
                                    }
                                   }
                                 }


                                 if (BollBsPer !== "N/A") {
                                   BollBsPerVal = parseFloat(BollBsPer).toFixed(2)
                                 } else {
                                   BollBsPerVal = "N/A";
                                 }



                                  return '<span data-boll_basis="'+newboll_basis+'" data-val="'+BollBsPerVal+'" id="boll_basischange'+row["USD"]["symbol"].toUpperCase()+'l" class="pchangeboll_basis doubleVal '+elemSize+' '+bollBBeh+' '+changeVal+'">'+BollBsPerVal+'%</span>';




                              }},



                              {title:"<span>BB:Upper <curr>$</curr></span>", width: "9%",targets: 7, visible: false, className:"boll up", data: function (row) {

                                if (row["USD"]["boll_upper"] == "NA") {
                                  BollUpPer = "N/A";
                                } else {
                                  BollUpPer =  -(1 - row["USD"]["current_price"]/row["USD"]["boll_upper"])*100;
                                }


                                   if (BollUpPer < 0) {
                                     changeVal = "negChange";
                                   } else {
                                     changeVal = "posChange";
                                   }

                                   bollUBeh = "";
                                   elemSize = "";


                                   if ((row["USD"]["boll_upper"] == "NA") || (!row["USD"]["boll_upper"])) {
                                     newboll_upper = "N/A";
                                   } else {
                                       if (convert(row["USD"]["boll_upper"]) > 20000) {
                                        newboll_upper = currency(row["USD"]["boll_upper"],{ precision: 0, symbol: '', separator: ',' }).format();
                                      } else if (convert(row["USD"]["boll_upper"]) > 1000) {
                                        newboll_upper = currency(row["USD"]["boll_upper"],{ precision: 2, symbol: '', separator: ',' }).format();
                                      } else if (convert(row["USD"]["boll_upper"]) > 0.01) {
                                        newboll_upper = parseFloat(convert(row["USD"]["boll_upper"])).toFixed(4);
                                      } else if (convert(row["USD"]["boll_upper"]) > 0.000001) {
                                        newboll_upper = parseFloat(convert(row["USD"]["boll_upper"])).toFixed(8);
                                      } else {
                                        newboll_upper = parseFloat(convert(row["USD"]["boll_upper"])).toFixed(12);
                                        elemSize = "smallsize";
                                      }
                                      newboll_upper += ' $';
                                    }


                                  if ($('#boll_upperchange'+row["USD"]["symbol"].toUpperCase()+'l').html()) {

                                   oldBollUEl = $('#boll_upperchange'+row["USD"]["symbol"].toUpperCase()+'l').attr("data-boll_upper");
                                   if (oldBollUEl) {
                                      oldBollU = parseFloat(oldBollUEl.replace(/[^0-9\.]+/g, ""));
                                      newboll_upperEl = parseFloat(newboll_upper.replace(/[^0-9\.]+/g, ""));
                                    if (oldBollUEl !== "N/A") {
                                      if (newboll_upperEl < oldBollU) {
                                        bollUBeh = "price_fall";
                                      } else if (newboll_upperEl == oldBollU) {
                                        bollUBeh = "";
                                      } else {
                                        bollUBeh = "price_rise";
                                      }
                                    }
                                    }
                                  }


                                  if (BollUpPer !== "N/A") {
                                    BollUpPerVal = parseFloat(BollUpPer).toFixed(2)
                                  } else {
                                    BollUpPerVal = "N/A";
                                  }



                                   return '<span data-boll_upper="'+newboll_upper+'" data-val="'+BollUpPerVal+'" id="boll_upperchange'+row["USD"]["symbol"].toUpperCase()+'l" class="pchangeboll_upper doubleVal '+elemSize+' '+bollUBeh+' '+changeVal+'">'+BollUpPerVal+'%</span>';



                                    }},




                                    {title:"<span>MACD:Histogram <curr>$</curr></span>", width: "9%",targets: 8, className:"macd", data: function (row) {

                                      if ((row["USD"]["histogram"] == "NA") || (!row["USD"]["histogram"])) {
                                          histogram = "N/A";
                                      } else {
                                          histogram = row["USD"]["histogram"]
                                       }

                                         if (histogram < 0) {
                                           changeVal = "negChange";
                                         } else {
                                           changeVal = "posChange";
                                         }

                                         macdBeh = "";
                                         elemSize = "";



                                        if ((histogram !== "N/A") && ((histogram !== "1e+100"))) {

                                          if (histogram < -50) {
                                            histogramVal = parseFloat(histogram).toFixed(0)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(0)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(0)
                                          } else if (histogram < -1) {
                                            histogramVal = parseFloat(histogram).toFixed(2)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(2)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(2)
                                          } else if (histogram < -0.01) {
                                            histogramVal = parseFloat(histogram).toFixed(4)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(4)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(4)
                                          } else if (histogram < -0.0001) {
                                            histogramVal = parseFloat(histogram).toFixed(5)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(5)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(5)
                                          } else if (histogram < -0.000001) {
                                            histogramVal = parseFloat(histogram).toFixed(6)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(6)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(6)
                                          } else if (histogram < -0.00000001) {
                                            histogramVal = parseFloat(histogram).toFixed(8)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(8)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(8)
                                          } else if (histogram == 0) {
                                            histogramVal = parseFloat(histogram).toFixed(2)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(2)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(2)
                                          } else if (histogram < 0.000009) {
                                            histogramVal = parseFloat(histogram).toFixed(8)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(8)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(8)
                                          } else if (histogram < 0.00009) {
                                            histogramVal = parseFloat(histogram).toFixed(5)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(5)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(5)
                                          } else if (histogram < 0.0009) {
                                            histogramVal = parseFloat(histogram).toFixed(5)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(5)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(5)
                                          } else  if (histogram < 0.09)  {
                                            histogramVal = parseFloat(histogram).toFixed(4);
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(4);
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(4);
                                          } else if (histogram < 30) {
                                            histogramVal = parseFloat(histogram).toFixed(2)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(2)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(2)
                                          } else if (histogram < 50) {
                                            histogramVal = parseFloat(histogram).toFixed(1)
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(1)
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(1)
                                          } else {
                                            histogramVal = parseFloat(histogram).toFixed(0);
                                            macdVal = parseFloat(row["USD"]["macd"]).toFixed(0);
                                            signalVal = parseFloat(row["USD"]["signal"]).toFixed(0);
                                          }

                                      } else {
                                          histogramVal = "N/A";
                                      }

                                      // return '<span data-val="'+histogramVal+'" id="macdchange'+row["USD"]["symbol"].toUpperCase()+'l" class="pchangemacd'+elemSize+' '+macdBeh+' '+changeVal+'">'+histogramVal+' <div class="macd_values"><span></span><span data-macd="'+macdVal+'"></span>  <span></span> <span data-signal="'+signalVal+'"></span>  </div> </span>';

                                      if (histogram > 0) {
                                        bearish_bullish = "bullish"
                                      } else {
                                        bearish_bullish = "bearish"
                                      }

                                      if (histogramVal == "N/A") {
                                        macdTooltip = '';
                                      } else {
                                        macdTooltip = '<div class="macd_values"><span></span><span data-macd="'+macdVal+'"></span>  <span></span> <span data-signal="'+signalVal+'"></span></div>'
                                      }

                                      return '<span data-val="'+histogramVal+'" id="macdchange'+row["USD"]["symbol"].toUpperCase()+'l" class="pchangemacd '+bearish_bullish+' '+elemSize+' '+macdBeh+' '+changeVal+'">'+histogramVal+' '+macdTooltip+'</span>';

                                    }},







                       {title:"<span>"+trans_Price_in+" ₿</span>", width: "11%", targets: 9, className:"priceBtc", data: function (row) {


                            elemSize = "";
                            priceBeh = "";

                            if (row[dcurrency]["symbol"] == "BTC") {
                              btcPrice = row[dcurrency]["current_price"];
                            }

                            if (btcPrice == 0) {
                              return '<span id="price'+row[dcurrency]["symbol"].toUpperCase()+'lBtc" class="priceBtc blur'+elemSize+' '+priceBeh+'"></span>';
                            } else {

                             priceInBtc = row[dcurrency]["current_price"] / btcPrice;

                             if (priceInBtc > 1) {
                              newPrice = currency(priceInBtc,{ precision: 2, symbol: '', separator: ',' }).format();
                            } else if (priceInBtc == 1) {
                              newPrice = currency(priceInBtc,{ precision: 0, symbol: '', separator: ',' }).format();
                            } else if (priceInBtc > 0.01) {
                              newPrice = currency(priceInBtc,{ precision: 4, symbol: '', separator: ',' }).format();
                            } else if (priceInBtc > 0.0001) {
                              newPrice = currency(priceInBtc,{ precision: 6, symbol: '', separator: ',' }).format();
                            } else if (priceInBtc > 0.000001) {
                              newPrice = currency(priceInBtc,{ precision: 8, symbol: '', separator: ',' }).format();
                              elemSize = "smallsize"
                            } else if (priceInBtc > 0.00000001) {
                              newPrice = currency(priceInBtc,{ precision: 10, symbol: '', separator: ',' }).format();
                              elemSize = "smallsize"
                            } else if (priceInBtc > 0.0000000001) {
                              newPrice = currency(priceInBtc,{ precision: 12, symbol: '', separator: ',' }).format();
                              elemSize = "smallsize"
                            } else if (priceInBtc > 0.000000000001) {
                              newPrice = currency(priceInBtc,{ precision: 14, symbol: '', separator: ',' }).format();
                              elemSize = "verysmallsize"
                            } else if (priceInBtc > 0.00000000000001) {
                              newPrice = currency(priceInBtc,{ precision: 16, symbol: '', separator: ',' }).format();
                              elemSize = "verysmallsize"
                            } else {
                              newPrice = currency(priceInBtc,{ precision: 17, symbol: '', separator: ',' }).format();
                              elemSize = "verysmallsize"
                            }



                            oldPriceEl = $('#price'+row[dcurrency]["symbol"].toUpperCase()+'lBtc').html();


                            if (oldPriceEl) {
                               oldPrice = parseFloat(oldPriceEl.replace(/[^0-9\.]+/g, ""));
                               if (newPrice < oldPrice) {
                                 priceBeh = "price_fall";
                               } else if (newPrice == oldPrice) {
                                 priceBeh = "";
                               } else {
                                 priceBeh = "price_rise";
                               }

                             }


                               return '<span id="price'+row[dcurrency]["symbol"].toUpperCase()+'lBtc" class="priceBtc '+elemSize+' '+priceBeh+'">'+newPrice+' ₿</span>';

                            }

                             }},




                             {title:"<span>"+trans_Price_in+" Ξ</span>", width: "11%", targets: 10, visible: false, className:"priceEth", data: function (row) {

                               elemSize = "";
                               priceBeh = "";

                               if (row[dcurrency]["symbol"] == "ETH") {
                                 ethPrice = row[dcurrency]["current_price"];
                               }

                               if (ethPrice == 0) {
                                 return '<span id="price'+row[dcurrency]["symbol"].toUpperCase()+'lEth" class="priceEth blur'+elemSize+' '+priceBeh+'"></span>';

                               } else {


                               priceInEth = row[dcurrency]["current_price"] / ethPrice;


                              if (priceInEth > 1) {
                               newPrice = currency(priceInEth,{ precision: 2, symbol: '', separator: ',' }).format();
                             } else if (priceInEth == 1) {
                               newPrice = currency(priceInEth,{ precision: 0, symbol: '', separator: ',' }).format();
                             } else if (priceInEth > 0.01) {
                               newPrice = currency(priceInEth,{ precision: 4, symbol: '', separator: ',' }).format();
                             } else if (priceInEth > 0.0001) {
                               newPrice = currency(priceInEth,{ precision: 6, symbol: '', separator: ',' }).format();
                             } else if (priceInEth > 0.000001) {
                               newPrice = currency(priceInEth,{ precision: 8, symbol: '', separator: ',' }).format();
                               elemSize = "smallsize"
                             } else if (priceInEth > 0.00000001) {
                               newPrice = currency(priceInEth,{ precision: 10, symbol: '', separator: ',' }).format();
                               elemSize = "smallsize"
                             } else if (priceInEth > 0.0000000001) {
                               newPrice = currency(priceInEth,{ precision: 12, symbol: '', separator: ',' }).format();
                               elemSize = "smallsize"
                             } else if (priceInEth > 0.000000000001) {
                               newPrice = currency(priceInEth,{ precision: 14, symbol: '', separator: ',' }).format();
                               elemSize = "verysmallsize"
                             } else {
                               newPrice = currency(priceInEth,{ precision: 16, symbol: '', separator: ',' }).format();
                               elemSize = "verysmallsize"
                             }




                              oldPriceEl = $('#price'+row[dcurrency]["symbol"].toUpperCase()+'lEth').html();
                              if (oldPriceEl) {
                                 oldPrice = parseFloat(oldPriceEl.replace(/[^0-9\.]+/g, ""));

                                 if (newPrice < oldPrice) {
                                   priceBeh = "price_fall";
                                 } else if (newPrice == oldPrice) {
                                   priceBeh = "";
                                 } else {
                                   priceBeh = "price_rise";
                                 }

                               }


                                 return '<span id="price'+row[dcurrency]["symbol"].toUpperCase()+'lEth" class="priceEth '+elemSize+' '+priceBeh+'">'+newPrice+' Ξ</span>';

                               }

                           }},








               {title:"<span>Ath <curr>$</curr></span>", width: "11%",targets: 11,className:"ath", data: function (row) {


                    if (row[dcurrency]["ath_change_percentage"] < 0) {
                      changeVal = "negChange";
                    } else {
                      changeVal = "posChange";
                    }


                    elemSize = "";
                    if (row[dcurrency]["ath"] > 20000) {
                     newAth = currency(row[dcurrency]["ath"],{ precision: 0, symbol: '', separator: ',' }).format();
                   } else if (row[dcurrency]["ath"] > 1000) {
                     newAth = currency(row[dcurrency]["ath"],{ precision: 2, symbol: '', separator: ',' }).format();
                   } else if (row[dcurrency]["ath"] > 0.000001) {
                     newAth = row[dcurrency]["ath"];
                   } else {
                     newAth = convert(row[dcurrency]["ath"]);
                     elemSize = "smallsize";
                   }




                    // return '<span class="ath-values"><div id="ath'+row[dcurrency]["symbol"].toUpperCase()+'l" class="athVal '+elemSize+'">'+newAth+' '+currencysymbole+'</div><div id="athchange'+row[dcurrency]["symbol"].toUpperCase()+'l" class="pchangeath '+changeVal+'" data-ath="'+row[dcurrency]["ath_change_percentage"]+'">'+parseFloat(row[dcurrency]["ath_change_percentage"]).toFixed(2)+'%</div></span>';

                    return '<span class="ath-values"><div data-ath="'+newAth+' $" id="athchange'+row[dcurrency]["symbol"].toUpperCase()+'l" class="pchangeath doubleVal '+elemSize+' '+changeVal+'" data-ath="'+row["USD"]["ath_change_percentage"]+'">'+parseFloat(row["USD"]["ath_change_percentage"]).toFixed(2)+'%</div></span>';



                     }},









                     {title:"<span>"+trans_age+"</span>",width: "9%", className:"age", name:"age", targets: 12, data: function (row) {

                       if (row["USD"]["age"] == "null") {
                         coinAgeDone = "N/A";
                         coinAge = "N/A";
                       } else {
                         coinAgeDone = convertDaystoPeriod(row["USD"]["age"])
                         coinAge = row["USD"]["age"];
                       }


                         return '<span data-val="'+coinAge+'">'+coinAgeDone+'</span>';

                       }},


                 {title:"<span>1h</span>", width: "9%", targets: 13, className:"oneh", data: function (row) {

                      onehInit = (row[dcurrency]["price_change_percentage_1h_in_currency"] - 1) * 100;



                        if (row[dcurrency]["price_change_percentage_1h_in_currency"] < 1) {
                          changeVal = " negChange";
                          oneh = parseFloat(onehInit).toFixed(2);
                          oneh = currency(oneh,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                        } else if (row[dcurrency]["price_change_percentage_1h_in_currency"] == "null") {
                          changeVal = "";
                          oneh = "N/A";
                          onehInit = "N/A"
                        } else {
                          changeVal = " posChange";
                          oneh = parseFloat(onehInit).toFixed(2);
                          oneh = currency(oneh,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                        }


                              return '<span id="1h'+row[dcurrency]["symbol"].toUpperCase()+'l" data-val="'+onehInit+'" class="pchange1y'+changeVal+'">'+oneh+'</span>';

                       }},

                 {title:"<span>24h</span>", width: "9%",targets: 14, className:"oned", data: function (row) {


                        onedayInit = (row[dcurrency]["price_change_percentage_24h"] - 1) * 100;

                        if (row[dcurrency]["price_change_percentage_24h"] < 1) {
                          changeVal = " negChange";
                          oneday = parseFloat(onedayInit).toFixed(2);
                          oneday = currency(oneday,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                        } else if (row[dcurrency]["price_change_percentage_24h"] == "null") {
                          changeVal = "";
                          oneday = "N/A";
                          onedayInit = "N/A"
                        } else {
                          changeVal = " posChange";
                          oneday = parseFloat(onedayInit).toFixed(2);
                          oneday = currency(oneday,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                        }


                              return '<span id="1d'+row[dcurrency]["symbol"].toUpperCase()+'l" data-val="'+onedayInit+'" class="pchange1y'+changeVal+'">'+oneday+'</span>';


                       }},


                 {title:"<span>7d</span>", width: "9%",targets: 15, className:"sevend", data: function (row) {

                   sevendaysInit = (row[dcurrency]["price_change_percentage_7d_in_currency"] - 1) * 100;


                   if (row[dcurrency]["price_change_percentage_7d_in_currency"] < 1) {
                     changeVal = " negChange";
                     sevendays = parseFloat(sevendaysInit).toFixed(2);
                     sevendays = currency(sevendays,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                   } else if (row[dcurrency]["price_change_percentage_7d_in_currency"] == "null") {
                     changeVal = "";
                     sevendays = "N/A";
                     sevendaysInit = "N/A"
                   } else {
                     changeVal = " posChange";
                     sevendays = parseFloat(sevendaysInit).toFixed(2);
                     sevendays = currency(sevendays,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                   }


                         return '<span id="7d'+row[dcurrency]["symbol"].toUpperCase()+'l" data-val="'+sevendaysInit+'" class="pchange1y'+changeVal+'">'+sevendays+'</span>';


                       }},






                 {title:"<span>30d</span>", width: "9%",targets: 16, className:"onem", data: function (row) {


                   onemonthInit = (row[dcurrency]["price_change_percentage_30d_in_currency"] - 1) * 100;


                     if (row[dcurrency]["price_change_percentage_30d_in_currency"] < 1) {
                       changeVal = " negChange";
                       onemonth = parseFloat(onemonthInit).toFixed(2);
                       onemonth = currency(onemonth,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                     } else if (row[dcurrency]["price_change_percentage_30d_in_currency"] == "null") {
                       changeVal = "";
                       onemonth = "N/A";
                       onemonthInit = "N/A"
                     } else {
                       changeVal = " posChange";
                       onemonth = parseFloat(onemonthInit).toFixed(2);
                       onemonth = currency(onemonth,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                     }


                           return '<span id="30d'+row[dcurrency]["symbol"].toUpperCase()+'l" data-val="'+onemonthInit+'" class="pchange1y'+changeVal+'">'+onemonth+'</span>';

                   }},


                 {title:"<span>90d</span>",  width: "9%",targets: 17, className:"nintyd", data: function (row) {


                   threemonthsInit = (row[dcurrency]["price_change_percentage_90d_in_currency"] - 1) * 100;


                    if (row[dcurrency]["price_change_percentage_90d_in_currency"] < 1) {
                      changeVal = " negChange";
                      threemonths = parseFloat(threemonthsInit).toFixed(2);
                      threemonths = currency(threemonths,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                    } else if (row[dcurrency]["price_change_percentage_90d_in_currency"] == "null") {
                      changeVal = "";
                      threemonths = "N/A";
                      threemonthsInit = "N/A"
                    } else {
                      changeVal = " posChange";
                      threemonths = parseFloat(threemonthsInit).toFixed(2);
                      threemonths = currency(threemonths,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                    }


                          return '<span id="90d'+row[dcurrency]["symbol"].toUpperCase()+'l" data-val="'+threemonthsInit+'" class="pchange1y'+changeVal+'">'+threemonths+'</span>';


                       }},


                 {title:"<span>1y</span>",  width: "9%",targets: 18, className:"oney", data: function (row) {


                   oneyearInit = (row[dcurrency]["price_change_percentage_1y_in_currency"] - 1) * 100;


                   if (row[dcurrency]["price_change_percentage_1y_in_currency"] < 1) {
                     changeVal = " negChange";
                     oneyear = parseFloat(oneyearInit).toFixed(2);
                     oneyear = currency(oneyear,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                   } else if (row[dcurrency]["price_change_percentage_1y_in_currency"] == "null") {
                     changeVal = "";
                     oneyear = "N/A";
                     oneyearInit = "N/A"
                   } else {
                     changeVal = " posChange";
                     oneyear = parseFloat(oneyearInit).toFixed(2);
                     oneyear = currency(oneyear,{ precision: 2, symbol: '', separator: ',' }).format()+'%';
                   }


                         return '<span id="1y'+row[dcurrency]["symbol"].toUpperCase()+'l" data-val="'+oneyearInit+'" class="pchange1y'+changeVal+'">'+oneyear+'</span>';


                       }},























                                          {title:"<span>"+trans_Volume24h+"</span>",width: "11%", className:"volume", name:"volume", targets: 19, data: function (row) {


                                                           mcBeh = "";
                                                           oldMcEl = $('#vol'+row[dcurrency]["symbol"].toUpperCase()+'l').html();
                                                           if (oldMcEl) {
                                                             newCurrency = oldMcEl.slice(-1);
                                                             if (currencysymbole == newCurrency) {
                                                              oldMc = parseFloat(oldMcEl.replace(/[^0-9\.]+/g, ""));
                                                              if (row[dcurrency]["volume"] < oldMc) {
                                                                mcBeh = "price_fall";
                                                              } else if (row[dcurrency]["volume"] == oldMc) {
                                                                mcBeh = "";
                                                              } else {
                                                                mcBeh = "price_rise";
                                                              }
                                                             }


                                                            }


                                                           volume = currency(parseFloat(row[dcurrency]["volume"]).toFixed(0),{ precision: 0, symbol: '', separator: ',' }).format();

                                                           return '<span class="live"><div id="vol'+row[dcurrency]["symbol"].toUpperCase()+'l" class="volume '+mcBeh+'">'+volume+' '+currencysymbole+'</div></span>'


                                            }},





                       {title:"<span>"+trans_CirculatingSupply+"</span>", width: "13%",targets: 20, className:"circuSupply", data: function (row) {



                         circSupply = parseFloat(row[dcurrency]["circulating_supply"]).toFixed(2);





                         if (row[dcurrency]["max_supply"] !== "null") {
                           maxSupply = parseFloat(row[dcurrency]["max_supply"]).toFixed(2);
                           supplyPerc = parseFloat(100*circSupply/maxSupply).toFixed(2);
                           maxSupply = currency(maxSupply,{ precision: 0, symbol: '', separator: ',' }).format();
                           supplyContainer = '<div class="supplyValCtn"><div class="line" style="width:'+supplyPerc+'%"></div> <div class="supplytt"><span></span><span data-perc="'+supplyPerc+'%"></span>  <span></span> <span data-mxs="'+maxSupply+'" data-curr="'+row[dcurrency]["symbol"].toUpperCase().replace(/_/g,'')+'"></span>  </div> </div>';
                           hasSupply = "hasSupply";
                         } else {
                           supplyContainer = '';
                           hasSupply = "";
                         }





                         circSupply = currency(circSupply,{ precision: 0, symbol: '', separator: ',' }).format();


                               return '<div class="supplyCell '+hasSupply+'"><span id="cirSupp'+row[dcurrency]["symbol"].toUpperCase()+'l" class="circSupply" data-curr="'+row[dcurrency]["symbol"].toUpperCase().replace(/_/g,'')+'">'+circSupply+'</span>'+supplyContainer+'</div>';


                             }},





             {title:"<span>"+trans_MarketCap+"</span>", width: "13%", className:"mcap", targets: 21, data: function (row) {

               mcBeh = "";
               oldMcEl = $('#mc'+row[dcurrency]["symbol"].toUpperCase()+'l').html();
               if (oldMcEl) {
                 newCurrency = oldMcEl.slice(-1);
                 if (currencysymbole == newCurrency) {
                  oldMc = parseFloat(oldMcEl.replace(/[^0-9\.]+/g, ""));
                  if (row[dcurrency]["market_cap"] < oldMc) {
                    mcBeh = "price_fall";
                  } else if (row[dcurrency]["market_cap"] == oldMc) {
                    mcBeh = "";
                  } else {
                    mcBeh = "price_rise";
                  }
                 }


                }


               mkt = currency(parseFloat(row[dcurrency]["market_cap"]).toFixed(0),{ precision: 0, symbol: '', separator: ',' }).format();

               return '<span class="live"><div id="mc'+row[dcurrency]["symbol"].toUpperCase()+'l" class="marketCap '+mcBeh+'">'+mkt+' '+currencysymbole+'</div></span>'

                   }},



             ],


             createdRow: function( row, data, dataIndex ) {
                 $(row).addClass(data.USD.name.toUpperCase().replace(/\s/g, ''));
             },

             columnDefs: [
               {  type: "num", targets: 1 },
               { orderable: false, targets: "noSort" },
               {type: 'numeric-val', targets: 4},
               {type: 'numeric-val', targets: 5},
               // {type: 'numeric-val', targets: 8},
               {type: 'numeric-val', targets: 6},
               {type: 'numeric-val', targets: 7},
                {type: 'numeric-val', targets: 8},
               {type: 'numeric-val', targets: 12},
               {type: 'numeric-val', targets: 13},
               {type: 'numeric-val', targets: 14},
               {type: 'numeric-val', targets: 15},
               {type: 'numeric-val', targets: 16},
               {type: 'numeric-val', targets: 17},
               {type: 'numeric-val', targets: 18}

             ],


             initComplete: function() {

               // number Filter S
               if ( topValue && (topValue != 1000)) {
                 $("#maxNumber").val(topValue);
                 JSTable.draw();
               }
               // number Filter E

               selectPersistedRows(JSTable);
               emptySvg();

               if (($('#CoinSearch').val().length) > 0) {
                 JSTable.search("").draw();
               }

               $('.processing_overlay').addClass('hide');
               $('#list-view').removeClass('loadingTable');

             }

         });

         // Merouane
         $('#crypto-table').on('draw.dt', function() {
           chartMd();
           selectPersistedRows(JSTable);

           if (lsLang == "de") {
             listCounting = $('#crypto-table_info').html().replace("Showing","").replace("to","bis").replace("of","von").replace("filtered from","gefiltert von");
           }

           if (lsLang == "fr") {
             listCounting = $('#crypto-table_info').html().replace("Showing","").replace("to","à").replace("of","sur").replace("filtered from","filtré sur ");
           }

           if (lsLang !== "en") {
             $('#crypto-table_info').html(listCounting)
           }


          });

         goofy = '';
         goofyNumber = '';
         goofyRsi = '';

         $('#crypto-table').on( 'order.dt',  function () {


           // Merouane AGE Start
           JSTable.column("age:name").every(function(i) {
             // this.visible() && console.log(i, this.header().innerHTML);
             goofy = i;
           });
           // Merouane AGE End

           // Merouane AGE Start
           JSTable.column("number:name").every(function(k) {
             // this.visible() && console.log(i, this.header().innerHTML);
             goofyNumber = k;
           });
           // Merouane AGE End


           // Merouane RSI Start
           JSTable.column("rsi:name").every(function(j) {
             // this.visible() && console.log(i, this.header().innerHTML);
             goofyRsi = j;
           });
           // Merouane RSI End

         });





         $('#crypto-table tbody').on('click', 'tr .watchlist-star-group', function(event){
           $(this.parentElement.parentElement).toggleClass('selected');
           // persistSelection( JSTable.row(this.parentElement.parentElement).index(), $(this.parentElement.parentElement).hasClass('selected'));

            persistSelection( $(this.parentElement.parentElement).attr("id"), $(this.parentElement.parentElement).hasClass('selected'));


            // MErouane
           selectPersistedRows(JSTable)
         });






         if (JSON.parse(localStorage.getItem('DataTables_crypto-table_'+window.location.pathname)).length) {
           firstlenght =  JSON.parse(localStorage.getItem('DataTables_crypto-table_'+window.location.pathname)).length;
         } else {
           firstlenght =  25;
         }


         // firstlenght =  25;



         $('#crypto-table').on( 'length.dt', function ( e, settings, len ) {
              if (len !== -1) {
                firstlenght = len;
                // console.log( 'New page length: '+len );
              }
          } );



          if (firstlenght) {
            $('input#'+firstlenght).prop( "checked", 'true' );
            var parent = $('input#'+firstlenght).closest(".set-parent");
            var selected = $('input#'+firstlenght);
            $(".radio-display", parent).attr("data-paging", selected.attr("id"));
            $(".radio-display .paging-label", parent).html(selected.attr("id"));
          }


          // console.log(firstlenght);







          var watchlist = $('input#watchlist');

          if (localStorage.getItem('watchlist', 'true')) {
            watchlist.prop( "checked", true );



            // JSTable.page.len(-1).rows( ':not(.selected)' ).remove().draw();

            JSTable.page.len(-1).draw();


            $('#crypto-table').addClass('watchlist');


            $( "tr.selected" ).last().addClass( "tooltipInside" );


            $('#crypto-table_info').addClass('hide');
            $('#crypto-table_paginate').addClass('hide');
            $('#pagingCtn').addClass('hide');

          } else {
            if (firstlenght == -1) {
              firstlenght = 25;
              JSTable.page.len(firstlenght).draw();
              $('input#'+firstlenght).prop( "checked", 'true' );
              var parent = $('input#'+firstlenght).closest(".set-parent");
              var selected = $('input#'+firstlenght);
              $(".radio-display", parent).attr("data-paging", selected.attr("id"));
              $(".radio-display .paging-label", parent).html(selected.attr("id"));
            }
          }


         watchlist.change(function() {
            if(this.checked) {
              localStorage.setItem('watchlist', 'true');
              JSTable.page.len(-1).search("").draw();

              // JSTable.page.len(-1).rows( ':not(.selected)' ).remove().draw();



              $('#crypto-table').addClass('watchlist');
              $( "tr.selected" ).last().addClass( "tooltipInside" );

              $('#crypto-table_info').addClass('hide');
              $('#crypto-table_paginate').addClass('hide');
              $('#pagingCtn').addClass('hide');
              $('.search-div').addClass('hide');
              $('#emptysi svg').addClass('hide');

              // $('.paging').addClass('hide');

              selectPersistedRows(JSTable);
            } else {

              localStorage.removeItem('watchlist', 'true');

              // JSTable.ajax.reload().page.len(25);



              if (firstlenght !== -1) {
                JSTable.page.len(firstlenght).draw();
              } else {
                firstlenght = 25;
                JSTable.page.len(firstlenght).draw();
              }



              $('input#'+firstlenght).prop( "checked", 'true' );
              var parent = $('input#'+firstlenght).closest(".set-parent");
              var selected = $('input#'+firstlenght);
              $(".radio-display", parent).attr("data-paging", selected.attr("id"));
              $(".radio-display .paging-label", parent).html(selected.attr("id"));


              $('#crypto-table').removeClass('watchlist');
              $( "tr.selected" ).last().removeClass( "tooltipInside" );

              $('#crypto-table_info').removeClass('hide');
              $('#crypto-table_paginate').removeClass('hide');
              $('#pagingCtn').removeClass('hide');
              // $('.paging').removeClass('hide');
              $('.search-div').removeClass('hide');
              // $('#CoinSearch').removeClass('hide');
              $('#wl-nresult').css("display","none");
              $('#list-view').removeClass("Emptywl");
            }
          });

          persistSelection();
          selectPersistedRows(JSTable)

          setInterval( function () {
             JSTable.ajax.reload(
               function () {
                 // console.log('reload: '+localStorage.watchlisted);
                  selectPersistedRows(JSTable);
                  emptySvg();
                  // Merouane
                  // if (localStorage.getItem('watchlist', 'true')) {
                  //   JSTable.page.len(-1).rows( ':not(.selected)' ).remove().draw();
                  // }

                  if (!$('.processing_overlay').hasClass('hide')) {
                    $('.processing_overlay').addClass('hide');
                  }

                }
                , false);
          }, 5000);








          $('#rwlnrsl').on('click', function(e) {
            localStorage.removeItem('watchlist', 'true');

            if (firstlenght == -1) {
                firstlenght = 25;
            }

            JSTable.page.len(firstlenght).draw();

            $('input#'+firstlenght).prop( "checked", 'true' );
            var parent = $('input#'+firstlenght).closest(".set-parent");
            var selected = $('input#'+firstlenght);
            $(".radio-display", parent).attr("data-paging", selected.attr("id"));
            $(".radio-display .paging-label", parent).html(selected.attr("id"));

            $('#crypto-table').removeClass('watchlist');
            $( "tr.selected" ).last().removeClass( "tooltipInside" );

            $('#crypto-table_info').removeClass('hide');
            $('#crypto-table_paginate').removeClass('hide');
            $('div:not("#togglebarholder") .dataTables_length').removeClass('hide');
            $('#pagingCtn').removeClass('hide');
            $('#wl-nresult').css("display","none");
            $('#list-view').removeClass("Emptywl");
            $('.search-div').removeClass('hide');
            // $('#CoinSearch').removeClass('hide');
            watchlist.prop( "checked", false );
          });


         JSTable.buttons().container().appendTo('#cr-dt-buttons');
         $('#list-view').removeClass('nooverflow');

         BtnVisSet();
         $('#crypto-table').on( 'column-visibility.dt', function (e) {
           BtnVisSet();
           tableScrollX();
           chartMd();
         });
         $('#resetOrder, #layoutClassic, #layoutIndicators, #layoutDeltas, #layoutAll, #set-settings').click( function (e) {
           BtnVisSet();
         } );


         function BtnVisSet(){
           var col_numb = JSTable.columns(':visible').count();
           // if (col_numb > 12) {
           //   // JSTable.buttons(':not(.active)').disable();
           //   // JSTable.buttons('.active').enable();
           //   // $('#visibilityLabel').removeClass('no');
           //   $('#possiCol').html(col_numb - 5);
           // } else {
           //   // JSTable.buttons(':not(.active)').enable();
           //   // $('#visibilityLabel').addClass('no');
             $('#possiCol').html(col_numb - 3);
           // }
         };


    // };


    if (localStorage.getItem('watchlist', 'true')) {
        $('.search-div').addClass('hide');
    } else {
        $('.search-div').removeClass('hide');
    }
    $('#crypto-table_filter').detach().appendTo('.search-div');
    $('#crypto-table_filter input').attr("id","CoinSearch");
    lsLang = localStorage.language;
    if (lsLang == "en") {
      searchPlaceholder = "Search"
    }
    if (lsLang == "de") {
      searchPlaceholder = "Suche"
    }
    if (lsLang == "fr") {
      searchPlaceholder = "Recherche"
    }
    $('#crypto-table_filter input,#searchMarkets,#searchMarketsHeader').attr('placeholder',searchPlaceholder);
    $('#crypto-table_filter input').attr('autocomplete','off');
    $('#crypto-table_length').detach().appendTo('.toggle-switch-placeholder');
 });





  // Currency change
  $('ul.menu-currency input').each(function(){
    let currencyname = $(this).attr('value');
    let incurrencysymbole = $(this).attr('currency-symbole');
    $(this).change(function() {
      dcurrency = currencyname;
      currencysymbole = incurrencysymbole;
      JSTable =  $('#crypto-table').DataTable();
      JSTable.ajax.reload(
        function () {
          // console.log('Currency change: '+localStorage.watchlisted);
          selectPersistedRows(JSTable);
         }
        , false);
      // console.log(currencyname);
      localStorage.setItem('currency', currencyname);
      localStorage.setItem('currency-symbole', currencysymbole);
      // Real time currency Change
      $('.coin').each(function(){
        let coin = $(this).attr('name');
      });
      tableScrollX()
    });
    if (localStorage.getItem("currency") == currencyname) {
      $('input#'+currencyname).prop( "checked", 'true' );
      var parent = $('input#'+currencyname).closest(".set-parent");
      var selected = $('input#'+currencyname);
      $(".radio-display", parent).attr("data-currency", selected.attr("id"));
      $(".radio-display .currency-label", parent).html(selected.attr("id"));
    }
  });

  movePaging();

  $( document ).ready(function() {
    $('#wl-toggle').css('display','inline-block');
    $('#gl-currency').css('display','inline-block');
    $('.search-div').css('display','inline-block');
    $( '#gl-switcher' ).css('display','block');
    $('span.rightArrow').css('visibility','visible');
    $('span.leftArrow').css('visibility','visible');
    $('.settings').css('display','inline-block');
    $('#pagingCtn').css('display','inline-block');

    cskeyup();



    $('#crypto-table_info').detach().appendTo('#tableInfo');
    $('#crypto-table_paginate').detach().appendTo('#tableInfo');

    persistTheadSticky();



    if ($(window).width() < 768) {
      $("#sidebarPrice").detach().prependTo("#chart-description")
    }


    $(window).on('resize', function(){
      if ($(this).width() < 768) {
        $("#sidebarPrice").detach().prependTo("#chart-description")
      } else {
        $("#sidebarPrice").detach().prependTo("#sidebar")
      }
    });
  });


  // Detect browser < > clicked
  if (window.history && window.history.pushState) {
  	$(window).on('popstate', function() {
      if (!window.location.search) {
        // console.log('no param');
        $('.modal').removeClass('is-visible');
        $('body').removeClass('nooverflow');

      } else {
        // console.log('param: '+window.location.search);
        searchParams = new URLSearchParams(window.location.search);
        chartParam();
      }
  	});
  }


  // escape close modal
 $(document).keyup(function(e) {
      if ((e.key === "Escape") || (e.key === 27)) {
         $('.modal').removeClass('is-visible');
         $('body').removeClass('nooverflow');

         document.title = homePageTitle;
         $('link[rel="canonical"]').attr("href", window.location.origin);
         $('meta[property="og:title"]').attr("content", homePageTitle);
         $('meta[name="description"]').attr("content", metaDesc);
         $('meta[property="og:description"]').attr("content", metaDesc);

         var uri = window.location.toString();
         if (uri.indexOf("?") > 0) {
             var clean_uri = uri.substring(0, uri.indexOf("?"));
             window.history.pushState({}, document.title, clean_uri);
         }
     }
 });




$('.modal-close').on('click', function(e) {
  e.preventDefault();
  $('.modal').removeClass('is-visible');
  $('body').removeClass('nooverflow');
  document.title = homePageTitle;
  $('link[rel="canonical"]').attr("href", window.location.origin);
  $('meta[property="og:title"]').attr("content", homePageTitle);
  $('meta[name="description"]').attr("content", metaDesc);
  $('meta[property="og:description"]').attr("content", metaDesc);

	var uri = window.location.toString();
	if (uri.indexOf("?") > 0) {
	    var clean_uri = uri.substring(0, uri.indexOf("?"));
	    window.history.pushState({}, document.title, clean_uri);
	}

});



  chartParam()

  // open modal & draw chart from URL params
  function chartParam() {
    // console.log('searchParam: '+searchParams);
    if ((searchParams.has('coin')) || searchParams.has('coin_market_cap')) {
        if (searchParams.has('coin')) {
           PriceParam = searchParams.get('coin').toUpperCase().replace(/\s/g, '').replace('/','');
           PriceParam2 = searchParams.get('coin').toUpperCase();

        } else {
          PriceParam = searchParams.get('coin_market_cap').toUpperCase().replace(/\s/g, '').replace('/','');
        }

        $.getJSON(apiUrl, function(data) {

          for (var i = 0; i < data.length; i++) {

            if ( (data[i]["USD"]["symbol"] == PriceParam) || (data[i]["USD"]["name"].toLowerCase() == PriceParam.toLowerCase()) || (data[i]["USD"]["symbol"].toLowerCase() == PriceParam2.toLowerCase()) ) {

              var current_tr_coinName = data[i]["USD"]["name"];
              var current_tr_coinDesc = data[i]["USD"]["symbol"].replace(/_/g,'');
              var chart_icon = data[i]["USD"]["image"];
              let chart_key = data[i]["USD"]["key"];
              let chart_desc = data[i]["USD"]["description"];
              chart_img = '<img style="border-radius:4px" width="35" height="35" alt='+current_tr_coinName+' src='+chart_icon+'>';
              twitterName = data[i]["USD"]["links"]["twitter"].replace(/^.*\/\/[^\/]+/, '').substring(1);


                ctdClass = this.classList;

                lsLang = localStorage.language;
                if (lsLang == "en") {
                  trans_PriceLiveChart = " Price Live Chart";
                  trans_whatIs = "What is ";
                  trans_convertedTo = "converted to ";
                  trans_priceToday = " price today, ";
                  trans_to = " to ";
                  trans_liveIndicatorsRSI = " live indicators, RSI, Bollinger Bands, MACD, technical analysis, price, marketcap and chart | cryptolyse.com";
                  trans_priceLiveCrypto = " price live, crypto indicators, crypto charts, market cap. RSI, Bollinger Bands, MACD";
                }
                if (lsLang == "de") {
                  trans_PriceLiveChart = " Live Preisdiagramm";
                  trans_whatIs = "Was ist ";
                  trans_convertedTo = "konvertiert zu ";
                  trans_priceToday = " Preis, ";
                  trans_to = " zu ";
                  trans_liveIndicatorsRSI = " Live-Indikatoren, RSI, Bollinger-Bänder, MACD, technische Analyse, Preis, Marktkapitalisierung und Chart | cryptolyse.com";
                  trans_priceLiveCrypto = " Preis live, Krypto-Indikatoren, Krypto-Charts, Marktkapitalisierung. RSI, Bollinger-Bänder, MACD";
                  $("input#MovingAverage").attr("placeholder","Länge");
                  $("label[for='toolbar'] span.label").html("Werkzeugleiste");
                  $("label[for='range'] span.label").html("Bereich");
                }
                if (lsLang == "fr") {
                  trans_PriceLiveChart = " Graphique";
                  trans_whatIs = "Qu'est-ce que ";
                  trans_convertedTo = "converti en ";
                  trans_priceToday = " prix, ";
                  trans_to = "-";
                  trans_liveIndicatorsRSI = " Indicateurs en direct, RSI, Bandes de Bollinger, MACD, analyse technique, prix, capitalisation boursière et graphique | cryptolyse.com"
                  trans_priceLiveCrypto = " Prix en direct, indicateurs crypto, graphiques crypto, capitalisation boursière. RSI, Bandes de Bollinger, MACD";
                  $("input#MovingAverage").attr("placeholder","longueur");
                  $("label[for='toolbar'] span.label").html("Barre d'outils");
                  $("label[for='range'] span.label").html("Plage");

                }

                // console.log(chart_key);
                var chart_keyFull = chart_key.split(":");
                if (searchParams.has('coin')) {
                  charttitle = current_tr_coinName+trans_PriceLiveChart;
                  chart_key1 = data[i]["USD"]["key"];
                  chartsubtitle = current_tr_coinDesc+chart_keyFull[1].replace(current_tr_coinDesc,'')+' • '+chart_keyFull[0];
                } else {
                  charttitle = current_tr_coinName+' Market Cap Live Chart';
                  chart_key1 = current_tr_coinDesc;
                  chartsubtitle = current_tr_coinDesc+' • Market Cap';
                }



                    if (dcurrency == "EUR") {
                      chart_key1 = chart_key1+'*'+chart_keyFull[1].replace(current_tr_coinDesc,'')+'EUR';
                      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' EUR)'
                    } else if (dcurrency == "GBP") {
                      chart_key1 = chart_key1+'*'+chart_keyFull[1].replace(current_tr_coinDesc,'')+'GBP';
                      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' GBP)'
                    } else if (dcurrency == "BTC") {
                      chart_key1 = chart_key1+'/BTC'+chart_keyFull[1].replace(current_tr_coinDesc,'');
                      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' BTC)'
                    } else if (dcurrency == "ETH") {
                      chart_key1 = chart_key1+'/ETH'+chart_keyFull[1].replace(current_tr_coinDesc,'');
                      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' ETH)'
                    }


                $('.charthead .hinfo h1').html(charttitle);
                $('.charthead .hinfo .h6').html(chartsubtitle);
                $('.charthead .chartsvg').html(chart_img);
                $('.modal.chart').scrollTop(0);
                $('.modal.chart').addClass('is-visible');
                $('body').addClass('nooverflow');
                if ($('#chartcontent').hasClass('toolbar')) {
                  st = 0;
                } else {
                  st = 1;
                }

                current_tr_coinName = current_tr_coinName.charAt(0).toUpperCase() + current_tr_coinName.slice(1);

                if ($('html').hasClass('dark-mode')) {
                  $('#chartcontent').html('<iframe title="'+current_tr_coinName+' Chart" id="tradingview_iframe" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_b1788&symbol='+chart_key1+'&interval=D&hide_side_toolbar='+st+'&symboledit=0&save_image=0&toolbarbg=f1f3f6&studies='+flexStudies+'&theme=dark&style='+styleValue+'&timezone=Etc%2FUTC&withdateranges=1&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%22header_chart_type%22%2C%22create_volume_indicator_by_default%22%2C%22header_indicators%22%2C%22header_compare%22%5D&locale='+chartLang+'&utm_source=&utm_medium=widget_new&utm_campaign=chart&utm_term='+chart_key+'"></iframe>');
                  $('#chart-description .chart-description-ph').html('<iframe title="'+current_tr_coinName+' Technical Analysis" src="https://s.tradingview.com/embed-widget/technical-analysis/?locale='+chartLang+'#%7B%22interval%22%3A%221D%22%2C%22width%22%3A%22100%25%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A%22463%22%2C%22symbol%22%3A%22'+chart_key+'%22%2C%22showIntervalTabs%22%3Atrue%2C%22colorTheme%22%3A%22dark%22%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22technical-analysis%22%7D" style="box-sizing: border-box; height: calc(463px); width: 100%;"></iframe>');
                  // $('#sidebarPrice').html('<iframe title="'+current_tr_coinName+' Price" scrolling="no" allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/single-quote/?locale='+chartLang+'#%7B%22symbol%22%3A%22'+chart_key1+'%22%2C%22width%22%3A%22100%25%22%2C%22colorTheme%22%3A%22dark%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A126%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22single-quote%22%7D" style="box-sizing: border-box; height: calc(94px); width: 100%;"></iframe>');
                } else {
                  $('#chartcontent').html('<iframe title="'+current_tr_coinName+' Chart" id="tradingview_iframe" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_b1788&symbol='+chart_key1+'&interval=D&hide_side_toolbar='+st+'&symboledit=0&save_image=0&toolbarbg=f1f3f6&studies='+flexStudies+'&theme=light&style='+styleValue+'&timezone=Etc%2FUTC&withdateranges=1&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%22header_chart_type%22%2C%22create_volume_indicator_by_default%22%2C%22header_indicators%22%2C%22header_compare%22%5D&locale='+chartLang+'&utm_source=&utm_medium=widget_new&utm_campaign=chart&utm_term='+chart_key+'"></iframe>');
                  $('#chart-description .chart-description-ph').html('<iframe title="'+current_tr_coinName+' Technical Analysis" src="https://s.tradingview.com/embed-widget/technical-analysis/?locale='+chartLang+'#%7B%22interval%22%3A%221D%22%2C%22width%22%3A%22100%25%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A%22463%22%2C%22symbol%22%3A%22'+chart_key+'%22%2C%22showIntervalTabs%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22technical-analysis%22%7D" style="box-sizing: border-box; height: calc(463px); width: 100%;"></iframe>');
                  // $('#sidebarPrice').html('<iframe title="'+current_tr_coinName+' Price" scrolling="no" allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/single-quote/?locale='+chartLang+'#%7B%22symbol%22%3A%22'+chart_key1+'%22%2C%22width%22%3A%22100%25%22%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A126%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22single-quote%22%7D" style="box-sizing: border-box; height: calc(94px); width: 100%;"></iframe>');
                }


                  coinMkts = JSON.stringify(data[i]["USD"]["markets"]).split(",");

                  keyMarketsArr = [];

                  for (var iM = 0; iM < coinMkts.length; iM++) {

                    if (coinMkts[iM].split(":")[0] && coinMkts[iM].split(":")[1]) {
                      coinMkt1 = coinMkts[iM].split(":")[0].replace('{','').replace('}','').replace('"','').replace('"','');
                      coinMkt2 = coinMkts[iM].split(":")[1].replace('{','').replace('}','').replace('"','').replace('"','');
                      coinMktDone = coinMkt1.toLowerCase().charAt(0).toUpperCase() + coinMkt1.toLowerCase().slice(1);
                      keyMarketsArr += '<tr><td><span class ="'+coinMkt1.split("_")[0].replace('.','')+'">'+coinMktDone.split("_")[0]+'</span></td><td><span>'+coinMkt2+'</span></td></tr>';
                    }

                  }

                  coinMktsEUR = JSON.stringify(data[i]["EUR"]["markets"]).split(",");

                  for (var iME = 0; iME < coinMktsEUR.length; iME++) {

                    if (coinMktsEUR[iME].split(":")[0] && coinMktsEUR[iME].split(":")[1]) {
                      coinMkt1E = coinMktsEUR[iME].split(":")[0].replace('{','').replace('}','').replace('"','').replace('"','');
                      coinMkt2E = coinMktsEUR[iME].split(":")[1].replace('{','').replace('}','').replace('"','').replace('"','');
                      coinMktDoneE = coinMkt1E.toLowerCase().charAt(0).toUpperCase() + coinMkt1E.toLowerCase().slice(1);
                      keyMarketsArr += '<tr><td><span class ="'+coinMkt1E.split("_")[0].replace('.','')+'">'+coinMktDoneE.split("_")[0]+'</span></td><td><span>'+coinMkt2E+'</span></td></tr>';
                    }

                  }



                  $('#markets table').html(keyMarketsArr);

                  $('#headerMarkets table').html(keyMarketsArr);


                  clickMarkets();

                  $('#coin-description .coin-description-ph').html(chart_desc);

                  $('#coin-description .coin-description-title').html("<h2>"+trans_whatIs+current_tr_coinName+"?</h2>");

                  initToolbar(chart_key);


                  $('#twitterWidget iframe').remove();
                  if ($('html').hasClass('dark-mode')) {
                      twitterTheme = 'theme=dark&transparent=true';
                  } else {
                      twitterTheme = 'theme=light';
                  }
                  if (twitterName !== 'ull') {
                    $('#twitterWidget').html('<iframe id="twitter-widget-0" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" class="" style="position: static; visibility: visible; width: 320px; height: 505px; border-radius:8px; display: block; flex-grow: 1;" title="Twitter Timeline" src="https://syndication.twitter.com/srv/timeline-profile/screen-name/'+twitterName+'?'+twitterTheme+'&frame=false&amp;hideBorder=true&amp;hideFooter=false&amp;hideHeader=false&amp;hideScrollBar=false&amp;lang='+langDone+'&amp;maxHeight=505px"></iframe>');
                  }

                  metaCharttitle = current_tr_coinName.charAt(0).toUpperCase() + current_tr_coinName.slice(1);
                  document.title = metaCharttitle+trans_priceToday+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_liveIndicatorsRSI;
                  $('meta[property="og:title"]').attr("content", metaCharttitle+trans_priceToday+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_liveIndicatorsRSI);

                  $('meta[name="description"]').attr("content", metaCharttitle+", "+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_priceLiveCrypto);
                  $('meta[property="og:description"]').attr("content", metaCharttitle+", "+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_priceLiveCrypto);

                  $('link[rel="canonical"]').attr("href", window.location.origin+'/?coin='+current_tr_coinDesc);
            }

          }

        });

    }


  }



  function insertParam(key, value) {
      // key = encodeURIComponent(key);
      // value = encodeURIComponent(value);
      var kvp = document.location.search.substr(1).split('&');
      let i=0;
      for(; i<kvp.length; i++){
        if (kvp[i].startsWith(key + '=')) {
            let pair = kvp[i].split('=');
            pair[1] = value;
            kvp[i] = pair.join('=');
            break;
        }
      }
      if(i >= kvp.length){
          kvp[kvp.length] = [key,value].join('=');
      }
      let params = kvp.join('');
      params = '?'+params;
      // console.log("params: "+params);
       window.history.pushState( {}, document.title, params );
  }



  function persistTheadSticky() {

      var scrollElTh = $('#list-view thead').offset().top;
      $( window ).scroll(function() {
        var scrollTopTh = $(window).scrollTop();
        if (scrollTopTh >= scrollElTh) {
          theadScroll = scrollTopTh - scrollElTh;
          $('#list-view thead').css("transform", "translateY("+theadScroll+"px)");

          $('#tableScBtnR').css("transform", "translateY("+theadScroll+"px)");
          $('#tableScBtnL').css("transform", "translateY("+theadScroll+"px)")
        } else {
          $('#list-view thead').css("transform", "translateY(0px)");

          $('#tableScBtnR').css("transform", "translateY(0px)");
          $('#tableScBtnL').css("transform", "translateY(0px)");
        }
      });

    }


  function emptySvg(){
    $("#emptysi svg").click(function(){
      $('#CoinSearch').val("");
      JSTable =  $('#crypto-table').DataTable();
      JSTable.page.len(firstlenght).search("").draw();
      $('#emptysi svg').addClass('hide');
      $('#db-results').addClass('hide');
    });
  }


  function cskeyup(){
    $('#CoinSearch').keyup(function(event){
    if ($('#CoinSearch').val().length >= 1) {
      $('#emptysi svg').removeClass('hide');
    } else {
      $('#emptysi svg').addClass('hide');
    }
   });
  }



  function chartMd() {

    $('table#crypto-table td.name, table#crypto-table td.price, table#crypto-table td.mcap, table#crypto-table td.rsi, table#crypto-table td.boll, table#crypto-table td.macd, table#crypto-table td.priceBtc, table#crypto-table td.priceEth').on('click', function(e) {
    e.preventDefault();

    $(".modal.chart, .modal-wrapper").animate({ scrollTop: 0 }, "fast");

    var current_tr_coinName = $(this.parentElement).children('td.name').find('span.ctitle h3').html();
    var current_tr_coinDesc = $(this.parentElement).children('td.name').find('span.ctitle .h6').html();
    var chart_icon = $(this.parentElement).children('td.name').find('img').attr('src');
    // console.log(chart_icon);

    chart_img = '<img style="border-radius:4px" width="35" height="35" alt='+current_tr_coinName+' src='+chart_icon+'>'
    ctdClass = this.classList;


    let chart_key = $(this.parentElement).children('td.name').find('.title-modal').attr('data-key');

    if (chart_key == "NA") {
      chart_key = current_tr_coinDesc+dcurrency;
    }



    let chart_desc = $(this.parentElement).children("td.name").find(".title-modal").attr("data-desc");

    var chart_keyFull = chart_key.split(":");

    lsLang = localStorage.language;
    if (lsLang == "en") {
      trans_PriceLiveChart = " Price Live Chart";
      trans_whatIs = "What is ";
      trans_convertedTo = "converted to ";
      trans_priceToday = " price today, ";
      trans_to = " to ";
      trans_liveIndicatorsRSI = " live indicators, RSI, Bollinger Bands, MACD, technical analysis, price, marketcap and chart | cryptolyse.com";
      trans_priceLiveCrypto = " price live, crypto indicators, crypto charts, market cap. RSI, Bollinger Bands, MACD";
    }
    if (lsLang == "de") {
      trans_PriceLiveChart = " Live Preisdiagramm";
      trans_whatIs = "Was ist ";
      trans_convertedTo = "konvertiert zu ";
      trans_priceToday = " Preis, ";
      trans_to = " zu ";
      trans_liveIndicatorsRSI = " Live-Indikatoren, RSI, Bollinger-Bänder, MACD, technische Analyse, Preis, Marktkapitalisierung und Chart | cryptolyse.com";
      trans_priceLiveCrypto = " Preis live, Krypto-Indikatoren, Krypto-Charts, Marktkapitalisierung. RSI, Bollinger-Bänder, MACD";
      $("input#MovingAverage").attr("placeholder","Länge");
      $("label[for='toolbar'] span.label").html("Werkzeugleiste");
      $("label[for='range'] span.label").html("Bereich");
    }
    if (lsLang == "fr") {
      trans_PriceLiveChart = " Graphique";
      trans_whatIs = "Qu'est-ce que ";
      trans_convertedTo = "converti en ";
      trans_priceToday = " prix, ";
      trans_to = "-";
      trans_liveIndicatorsRSI = " Indicateurs en direct, RSI, Bandes de Bollinger, MACD, analyse technique, prix, capitalisation boursière et graphique | cryptolyse.com"
      trans_priceLiveCrypto = " Prix en direct, indicateurs crypto, graphiques crypto, capitalisation boursière. RSI, Bandes de Bollinger, MACD";
      $("input#MovingAverage").attr("placeholder","longueur");
      $("label[for='toolbar'] span.label").html("Barre d'outils");
      $("label[for='range'] span.label").html("Plage");

    }


    if (ctdClass.contains('mcap')) {
      charttitle = current_tr_coinName+' Market Cap Live Chart';
      chart_key1 = current_tr_coinDesc;
      chartsubtitle = current_tr_coinDesc+' • Market Cap';
      insertParam('coin_market_cap',current_tr_coinDesc)

    } else {
      charttitle = current_tr_coinName+trans_PriceLiveChart;
      chart_key1 = $(this.parentElement).children('td.name').find('.title-modal').attr('data-key');

      if (chart_key1 == "NA") {
        chart_key1 = current_tr_coinDesc+dcurrency;
        chartsubtitle = current_tr_coinDesc;
      } else {
        chartsubtitle = current_tr_coinDesc+chart_keyFull[1].replace(current_tr_coinDesc,'')+' • '+chart_keyFull[0];
      }

      if (ctdClass.contains('rsi')) {

        insertParam('coin',current_tr_coinDesc+'&RSI')

        flexStudies = encodeURIComponent('[{"id":"RSI@tv-basicstudies","inputs":{"length":14}}]');

        $('input#rsi').prop( "checked", true );
        $('input#macd').prop( "checked", false );
        $('input#Bollinger').prop( "checked", false );
        $('input#MovingAverage').val("");

      } else if (ctdClass.contains('boll')) {

        insertParam('coin',current_tr_coinDesc+'&BOLLINGER')

        flexStudies = encodeURIComponent('[{"id":"BB@tv-basicstudies"}]');

        $('input#Bollinger').prop( "checked", true );
        $('input#rsi').prop( "checked", false );
        $('input#macd').prop( "checked", false );
        $('input#MovingAverage').val("");

      } else if (ctdClass.contains('macd')) {

        insertParam('coin',current_tr_coinDesc+'&MACD')

        flexStudies = encodeURIComponent('[{"id":"MACD@tv-basicstudies"}]');

        // flexStudies = encodeURIComponent('[{"id":"IchimokuCloud@tv-basicstudies"}]');


        $('input#Bollinger').prop( "checked", false );
        $('input#rsi').prop( "checked", false );
        $('input#macd').prop( "checked", true );
        $('input#MovingAverage').val("");


      } else {
        insertParam('coin',current_tr_coinDesc)
        flexStudies = "";
        $('input#Bollinger').prop( "checked", false );
        $('input#rsi').prop( "checked", false );
        $('input#macd').prop( "checked", false );
        $('input#MovingAverage').val("");
      }

    }




    if (dcurrency == "EUR") {
      chart_key1 = chart_key1+'*'+chart_keyFull[1].replace(current_tr_coinDesc,'')+'EUR';
      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' EUR)'
    } else if (dcurrency == "GBP") {
      chart_key1 = chart_key1+'*'+chart_keyFull[1].replace(current_tr_coinDesc,'')+'GBP';
      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' GBP)'
    } else if (dcurrency == "BTC") {
      chart_key1 = chart_key1+'/BTC'+chart_keyFull[1].replace(current_tr_coinDesc,'');
      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' BTC)'
    } else if (dcurrency == "ETH") {
      chart_key1 = chart_key1+'/ETH'+chart_keyFull[1].replace(current_tr_coinDesc,'');
      chartsubtitle = chartsubtitle+' ('+trans_convertedTo+' ETH)'
    }


    if (ctdClass.contains('priceBtc')) {
      chart_key1 = chart_key1+'/BTC'+chart_keyFull[1].replace(current_tr_coinDesc,'');
      chart_key1 = chart_key1.replace("*USDEUR","");
      chartsubtitle = chartsubtitle+' (converted to BTC)'

    }

    if (ctdClass.contains('priceEth')) {
      chart_key1 = chart_key1+'/ETH'+chart_keyFull[1].replace(current_tr_coinDesc,'');
      chart_key1 = chart_key1.replace("*USDEUR","");
      chartsubtitle = chartsubtitle+' (converted to ETH)'

    }


    metaCharttitle = current_tr_coinName.charAt(0).toUpperCase() + current_tr_coinName.slice(1);
    document.title = metaCharttitle+trans_priceToday+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_liveIndicatorsRSI;
    $('meta[property="og:title"]').attr("content", metaCharttitle+trans_priceToday+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_liveIndicatorsRSI);

    $('meta[name="description"]').attr("content", metaCharttitle+", "+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_priceLiveCrypto);
    $('meta[property="og:description"]').attr("content", metaCharttitle+", "+current_tr_coinDesc+trans_to+chart_keyFull[1].replace(current_tr_coinDesc,'')+trans_priceLiveCrypto);

    $('link[rel="canonical"]').attr("href", window.location.origin+'/?coin='+current_tr_coinDesc);

    // console.log('Key 1: '+chart_key1);

    if ($('#chartcontent').hasClass('toolbar')) {
      st = 0;
    } else {
      st = 1;
    }


    charttitleDone = charttitle.charAt(0).toUpperCase() + charttitle.slice(1);
    current_tr_coinName = current_tr_coinName.charAt(0).toUpperCase() + current_tr_coinName.slice(1);
    $('.charthead .hinfo h1').html(charttitleDone);
    $('.charthead .hinfo .h6').html(chartsubtitle);
    $('.charthead .chartsvg').html(chart_img);
    $('.modal.chart').scrollTop(0);
    $('.modal.chart').addClass('is-visible');
    $('body').addClass('nooverflow');
    if ($('html').hasClass('dark-mode')) {
      $('#chartcontent').html('<iframe title="'+current_tr_coinName+' Chart" id="tradingview_iframe" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_b1788&symbol='+chart_key1+'&interval=D&hide_side_toolbar='+st+'&symboledit=0&save_image=0&toolbarbg=f1f3f6&studies='+flexStudies+'&theme=dark&style='+styleValue+'&timezone=Etc%2FUTC&withdateranges=1&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%22header_chart_type%22%2C%22create_volume_indicator_by_default%22%2C%22header_indicators%22%2C%22header_compare%22%5D&locale='+chartLang+'&utm_source=&utm_medium=widget_new&utm_campaign=chart&utm_term='+chart_key+'"></iframe>');
      $('#chart-description .chart-description-ph').html('<iframe title="'+current_tr_coinName+' Technical Analysis" src="https://s.tradingview.com/embed-widget/technical-analysis/?locale='+chartLang+'#%7B%22interval%22%3A%221D%22%2C%22width%22%3A%22100%25%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A%22463%22%2C%22symbol%22%3A%22'+chart_key+'%22%2C%22showIntervalTabs%22%3Atrue%2C%22colorTheme%22%3A%22dark%22%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22technical-analysis%22%7D" style="box-sizing: border-box; height: calc(463px); width: 100%;"></iframe>');
      // $('#sidebarPrice').html('<iframe title="'+current_tr_coinName+' Price" scrolling="no" allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/single-quote/?locale='+chartLang+'#%7B%22symbol%22%3A%22'+chart_key1+'%22%2C%22width%22%3A%22100%25%22%2C%22colorTheme%22%3A%22dark%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A126%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22single-quote%22%7D" style="box-sizing: border-box; height: calc(94px); width: 100%;"></iframe>');
    } else {
      $('#chartcontent').html('<iframe title="'+current_tr_coinName+' Chart" id="tradingview_iframe" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_b1788&symbol='+chart_key1+'&interval=D&hide_side_toolbar='+st+'&symboledit=0&save_image=0&toolbarbg=f1f3f6&studies='+flexStudies+'&theme=light&style='+styleValue+'&timezone=Etc%2FUTC&withdateranges=1&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%22header_chart_type%22%2C%22create_volume_indicator_by_default%22%2C%22header_indicators%22%2C%22header_compare%22%5D&locale='+chartLang+'&utm_source=&utm_medium=widget_new&utm_campaign=chart&utm_term='+chart_key+'"></iframe>');
      $('#chart-description .chart-description-ph').html('<iframe title="'+current_tr_coinName+' Technical Analysis" src="https://s.tradingview.com/embed-widget/technical-analysis/?locale='+chartLang+'#%7B%22interval%22%3A%221D%22%2C%22width%22%3A%22100%25%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A%22463%22%2C%22symbol%22%3A%22'+chart_key+'%22%2C%22showIntervalTabs%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22technical-analysis%22%7D" style="box-sizing: border-box; height: calc(463px); width: 100%;"></iframe>');
      // $('#sidebarPrice').html('<iframe title="'+current_tr_coinName+' Price" scrolling="no" allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/single-quote/?locale='+chartLang+'#%7B%22symbol%22%3A%22'+chart_key1+'%22%2C%22width%22%3A%22100%25%22%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A126%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22single-quote%22%7D" style="box-sizing: border-box; height: calc(94px); width: 100%;"></iframe>');
    }


    $('#markets').scrollTop(0);
    $('#headerMarkets').scrollTop(0);
    $('.coin-description-ph').scrollTop(0);
    $('#searchMarkets').val('');
    $('#searchMarketsHeader').val('');
    $('#noMarketsHeader').toggle(false);
    $('#noMarkets').toggle(false);

    $.getJSON(apiUrl, function(data) {

      for (var i = 0; i < data.length; i++) {

        if ( (data[i]["USD"]["symbol"].replace(/_/g,'') == current_tr_coinDesc) || (data[i]["USD"]["name"].toLowerCase() == current_tr_coinDesc.toLowerCase()) ) {


        coinMkts = JSON.stringify(data[i]["USD"]["markets"]).split(",");

        keyMarketsArr = [];

        for (var iM = 0; iM < coinMkts.length; iM++) {

          if (coinMkts[iM].split(":")[0] && coinMkts[iM].split(":")[1]) {
            coinMkt1 = coinMkts[iM].split(":")[0].replace('{','').replace('}','').replace('"','').replace('"','');
            coinMkt2 = coinMkts[iM].split(":")[1].replace('{','').replace('}','').replace('"','').replace('"','');
            coinMktDone = coinMkt1.toLowerCase().charAt(0).toUpperCase() + coinMkt1.toLowerCase().slice(1);
            keyMarketsArr += '<tr><td><span class ="'+coinMkt1.split("_")[0].replace('.','')+'">'+coinMktDone.split("_")[0]+'</span></td><td><span>'+coinMkt2+'</span></td></tr>';
          }

        }

        coinMktsEUR = JSON.stringify(data[i]["EUR"]["markets"]).split(",");

        for (var iME = 0; iME < coinMktsEUR.length; iME++) {

          if (coinMktsEUR[iME].split(":")[0] && coinMktsEUR[iME].split(":")[1]) {
            coinMkt1E = coinMktsEUR[iME].split(":")[0].replace('{','').replace('}','').replace('"','').replace('"','');
            coinMkt2E = coinMktsEUR[iME].split(":")[1].replace('{','').replace('}','').replace('"','').replace('"','');
            coinMktDoneE = coinMkt1E.toLowerCase().charAt(0).toUpperCase() + coinMkt1E.toLowerCase().slice(1);
            keyMarketsArr += '<tr><td><span class ="'+coinMkt1E.split("_")[0].replace('.','')+'">'+coinMktDoneE.split("_")[0]+'</span></td><td><span>'+coinMkt2E+'</span></td></tr>';
          }

        }

        $('#markets table').html(keyMarketsArr);

        $('#headerMarkets table').html(keyMarketsArr);



      }
    }
      clickMarkets();

    });


    // console.log("chart_desc1: "+chart_desc);

    $('#coin-description .coin-description-ph').html(chart_desc.replaceAll("_apstrph","'"));

    $('#coin-description .coin-description-title').html("<h2>"+trans_whatIs+current_tr_coinName+"?</h2>");

    initToolbar(chart_key);

    twitterName = $(this.parentElement).children('td.name').find('.title-modal').attr('data-twitter');
    // console.log('Twitter: ',twitterName);
    $('#twitterWidget iframe').remove();
    if ($('html').hasClass('dark-mode')) {
        twitterTheme = 'theme=dark&transparent=true';
    } else {
        twitterTheme = 'theme=light';
    }
    if (twitterName !== 'ull') {
      $('#twitterWidget').html('<iframe id="twitter-widget-0" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" class="" style="position: static; visibility: visible; width: 320px; height: 505px; border-radius:8px; display: block; flex-grow: 1;" title="Twitter Timeline" src="https://syndication.twitter.com/srv/timeline-profile/screen-name/'+twitterName+'?'+twitterTheme+'&frame=false&amp;hideBorder=true&amp;hideFooter=false&amp;hideHeader=false&amp;hideScrollBar=false&amp;lang='+langDone+'&amp;maxHeight=505px"></iframe>');
    }

  });




}



  function clickMarkets() {

    $('table#marketsTable tr, #headerMarkets tr').on('click', function(e) {

      chart_key1 = $(this).find('td:first span').html().replace('.','').replace(' ','').toUpperCase()+':'+$(this).find('td:nth-child(2) span').html();

      $('.modal span.h6').html($(this).find('td:nth-child(2) span').html()+' • '+$(this).find('td:first span').html().toUpperCase())

      if ($('html').hasClass('dark-mode')) {
        $('#chartcontent').html('<iframe title="Chart" id="tradingview_iframe" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_b1788&symbol='+chart_key1+'&interval=D&hide_side_toolbar='+st+'&symboledit=0&save_image=0&toolbarbg=f1f3f6&studies='+flexStudies+'&theme=dark&style='+styleValue+'&timezone=Etc%2FUTC&withdateranges=1&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%22header_chart_type%22%2C%22create_volume_indicator_by_default%22%2C%22header_indicators%22%2C%22header_compare%22%5D&locale='+chartLang+'&utm_source=&utm_medium=widget_new&utm_campaign=chart&utm_term='+chart_key1+'"></iframe>');
        // $('#chart-description .chart-description-ph').html('<iframe title="Technical Analysis" src="https://s.tradingview.com/embed-widget/technical-analysis/?locale='+chartLang+'#%7B%22interval%22%3A%221D%22%2C%22width%22%3A%22100%25%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A%22463%22%2C%22symbol%22%3A%22'+chart_key1+'%22%2C%22showIntervalTabs%22%3Atrue%2C%22colorTheme%22%3A%22dark%22%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22technical-analysis%22%7D" style="box-sizing: border-box; height: calc(463px); width: 100%;"></iframe>');
      } else {
        $('#chartcontent').html('<iframe title="Chart" id="tradingview_iframe" src="https://s.tradingview.com/widgetembed/?frameElementId=tradingview_b1788&symbol='+chart_key1+'&interval=D&hide_side_toolbar='+st+'&symboledit=0&save_image=0&toolbarbg=f1f3f6&studies='+flexStudies+'&theme=light&style='+styleValue+'&timezone=Etc%2FUTC&withdateranges=1&studies_overrides=%7B%7D&overrides=%7B%7D&enabled_features=%5B%5D&disabled_features=%5B%22header_chart_type%22%2C%22create_volume_indicator_by_default%22%2C%22header_indicators%22%2C%22header_compare%22%5D&locale='+chartLang+'&utm_source=&utm_medium=widget_new&utm_campaign=chart&utm_term='+chart_key1+'"></iframe>');
        // $('#chart-description .chart-description-ph').html('<iframe title="Technical Analysis" src="https://s.tradingview.com/embed-widget/technical-analysis/?locale='+chartLang+'#%7B%22interval%22%3A%221D%22%2C%22width%22%3A%22100%25%22%2C%22isTransparent%22%3Atrue%2C%22height%22%3A%22463%22%2C%22symbol%22%3A%22'+chart_key1+'%22%2C%22showIntervalTabs%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22utm_source%22%3A%22'+utm_info_link+'%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22technical-analysis%22%7D" style="box-sizing: border-box; height: calc(463px); width: 100%;"></iframe>');
      }

    })

  }

  function searchMarkets() {

      var input = document.getElementById("searchMarkets");
      var filter = input.value.toUpperCase();
      var isMatchMkt = false;
      var lisMkts = document.querySelectorAll('#marketsTable tr');
      for (var i = 0; i < lisMkts.length; i++) {
          var name = lisMkts[i].textContent.toUpperCase();
          if (name.toUpperCase().indexOf(filter) == -1) {
              lisMkts[i].classList.add("hide")
          } else {
              lisMkts[i].classList.remove("hide")
              isMatchMkt = true;
          }
      }

      $('#noMarkets').toggle(!isMatchMkt);

  }



  function initToolbar(chart_key) {

    br = '';
    br1 = '';
    br2 = '';

    // RSI live change
    $("input#rsi").change(function() {
      if(this.checked) {
        rsiStudie =  '{"id":"RSI@tv-basicstudies","inputs":{"length":14}}';

        urlParam = new URLSearchParams(window.location.search);
        window.history.pushState( {}, document.title, '?coin='+urlParam.get('coin').replace('/','')+'&RSI' );

      } else {
        rsiStudie = '';

        urlParam = new URLSearchParams(window.location.search);
        window.history.pushState( {}, document.title, '?coin='+urlParam.get('coin') );
      }
      // console.log(studies);
      flexStudies = encodeURIComponent('['+rsiStudie+']');
      calcStudies(chart_key);



    });


    // Bollinger live change
    $("input#Bollinger").change(function() {
      if(this.checked) {
        bob =  '{"id":"BB@tv-basicstudies"}';

        urlParam = new URLSearchParams(window.location.search);
        window.history.pushState( {}, document.title, '?coin='+urlParam.get('coin').replace('/','')+'&BOLLINGER' );

      } else {
        bob = '';

        urlParam = new URLSearchParams(window.location.search);
        window.history.pushState( {}, document.title, '?coin='+urlParam.get('coin') );
      }
      // console.log(studies);
      flexStudies = encodeURIComponent('['+bob+']');
      calcStudies(chart_key);
    });

    // MACD live change
    $("input#macd").change(function() {
      if(this.checked) {
        macd =  '{"id":"MACD@tv-basicstudies"}';

        urlParam = new URLSearchParams(window.location.search);
        window.history.pushState( {}, document.title, '?coin='+urlParam.get('coin').replace('/','')+'&MACD' );

      } else {
        macd = '';

        urlParam = new URLSearchParams(window.location.search);
        window.history.pushState( {}, document.title, '?coin='+urlParam.get('coin') );
      }
      // console.log(studies);
      flexStudies = encodeURIComponent('['+macd+']');
      calcStudies(chart_key);
    });



    // MA dropdown click
    $('#MA-menu ul li').click( function (e) {
      fdays = $(this).attr('data-lenght');
      $('input#MovingAverage').val(fdays);
      calcStudies(chart_key);
      $('#MA-menu').removeClass('active');
    });


    $("input#MovingAverage").keyup(delay(function (e) {
      calcStudies(chart_key);
     }, 600));

    // MA Enter click
    $("input#MovingAverage").on('keyup', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          calcStudies(chart_key);
        }
    });
  }

  function movePaging() {
    $( window ).scroll(function() {
      var scrollTop = $(window).scrollTop();
      var scrollEl = $('#pagingCtn').offset().top;
      if (scrollEl !== 0) {
        if ((scrollEl - scrollTop) < -25) {
          $('div.paging').detach().appendTo('#tableInfo')
        } else {
          $('div.paging').detach().appendTo('#pagingCtn')
        }
      }
    });
  }


  function delay(callback, ms) {
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }


function convertDaystoPeriod(numberOfDays) {
  if (numberOfDays >= 365) {
    coinAge = (numberOfDays/365).toFixed(1)+' y';
    return coinAge;
  } else if (numberOfDays >= 30) {
    coinAge = (numberOfDays/30).toFixed(1)+' m';
    return coinAge;
  } else if (numberOfDays > 7) {
    coinAge = (numberOfDays/7).toFixed(1)+' w';
    return coinAge;
  } else {
    coinAge = numberOfDays+' d';
    return coinAge;
  }
}




  function convert(n){
       var sign = +n < 0 ? "-" : "",
           toStr = n.toString();
       if (!/e/i.test(toStr)) {
           return n;
       }
       var [lead,decimal,pow] = n.toString()
           .replace(/^-/,"")
           .replace(/^([0-9]+)(e.*)/,"$1.$2")
           .split(/e|\./);
       return +pow < 0
           ? sign + "0." + "0".repeat(Math.max(Math.abs(pow)-1 || 0, 0)) + lead + decimal
           : sign + lead + (+pow >= decimal.length ? (decimal + "0".repeat(Math.max(+pow-decimal.length || 0, 0))) : (decimal.slice(0,+pow)+"."+decimal.slice(+pow)))
   }



   function selectPersistedRows(table) {
     if (!(localStorage.watchlisted))
       return;
     var rowKeys = JSON.parse(localStorage.watchlisted);
     compareCoins = [];
     neuWi = 0;
    for (var key in rowKeys)
     {

       if (table.row('#'+key).node()) {
         $(table.row('#'+key).node()).addClass('selected');
         // neuWi++;
         // foo2 = key.toUpperCase();
         // compareCoins += foo2.replace(/_/g,'')+',';
       }

       neuWi++;
       compareCoins += key.replace(/_/g,'')+',';

     }
     $( "tr.selected" ).last().addClass( "tooltipInside" );

     $('#wl-toggleht').html(neuWi);

     if (neuWi == 0) {
       $('#commpareWatchlist').css('display','none');
     } else {
       $('#commpareWatchlist').css('display','inline-block');
     }

     if ((neuWi == 0) && ($('input#watchlist').is(':checked'))) {
       $('#wl-nresult').css("display","block");
       $('#list-view').addClass("Emptywl");
     } else {
       $('#wl-nresult').css("display","none");
       $('#list-view').removeClass("Emptywl");
     }

     if (compareCoins) {
       compareCoins = compareCoins.toString().substring(0, compareCoins.length - 1);
       $('#commpareWatchlist a').attr("href", "/compare/?coins=" + compareCoins);
       // console.log('compare A updated!');
     }

   }




   function persistSelection( index, isSelected ) {
     var ls = localStorage;
     if (!(ls.watchlisted))
     {
       ls.watchlisted = "{}";
     }
     var rowKeys = JSON.parse(ls.watchlisted);
     if (isSelected === false && rowKeys.hasOwnProperty(index))
     {
       // console.log('removing row ' + index + ' from selection list');
       delete rowKeys[index];
     }
     else if (isSelected)
     {
       rowKeys[index] = true;
     }
     ls.watchlisted = JSON.stringify(rowKeys);
   }








   $(document).ready(function () {

     // Merouane Age Filter Start

       var minEl = $('#min');
       var maxEl = $('#max');

       var minRsiEl = $('#minRsi');
       var maxRsiEl = $('#maxRsi');

       var minNumberEl = $('#minNumber');
       var maxNumberEl = $('#maxNumber');



      JSTable = $('#crypto-table').DataTable();

      JSTable.on( 'column-reorder', function ( e, settings, details ) {


           // Merouane AGE Start
           JSTable.column("age:name").every(function(i) {
             // this.visible() && console.log(i, this.header().innerHTML)
             goofy = i;
           });
           // Merouane AGE End

           // Merouane AGE Start
           JSTable.column("number:name").every(function(k) {
             // this.visible() && console.log(i, this.header().innerHTML)
             goofyNumber = k;
           });
           // Merouane AGE End

           // Merouane RSI Start
           JSTable.column("rsi:name").every(function(j) {
             // this.visible() && console.log(j, this.header().innerHTML)
             goofyRsi = j;
           });
           // Merouane RSI End

       });


       $.fn.dataTable.ext.search.push(
         function (settings, data, dataIndex) {
           var min = parseInt(minEl.val(), 10);
           var max = parseInt(maxEl.val(), 10);
           var age = parseFloat($(data[goofy]).attr("data-val")) || 'N/A'; // use data for the age column
           // console.log('age: '+age);

           if (( (isNaN(min) && isNaN(max)) || (isNaN(min) && age <= max) || (min <= age && isNaN(max)) || (min <= age && age <= max) )) {
               return true;
           }

           return false;
         }
       );


       $.fn.dataTable.ext.search.push(
         function (settings, data, dataIndex) {
           var minNumber = parseInt(minNumberEl.val(), 10);
           var maxNumber = parseInt(maxNumberEl.val(), 10);

           var number = parseFloat(data[goofyNumber]) || 'N/A'; // use data for the number column

           // console.log('number: '+number);

           if (( (isNaN(minNumber) && isNaN(maxNumber)) || (isNaN(minNumber) && number <= maxNumber) || (minNumber <= number && isNaN(maxNumber)) || (minNumber <= number && number <= maxNumber) ) ) {
               return true;
           }

           return false;
         }
       );


       $.fn.dataTable.ext.search.push(
         function (settings, data, dataIndex) {
           var minRsi = parseInt(minRsiEl.val(), 10);
           var maxRsi = parseInt(maxRsiEl.val(), 10);
           var rsi = parseFloat($(data[goofyRsi]).attr("data-val")) || 'N/A'; // use data for the rsi column

           // console.log('rsi: '+rsi);

           if (( (isNaN(minRsi) && isNaN(maxRsi)) || (isNaN(minRsi) && rsi <= maxRsi) || (minRsi <= rsi && isNaN(maxRsi)) || (minRsi <= rsi && rsi <= maxRsi) ) ) {
               return true;
           }

           return false;
         }
       );


       // Changes to the inputs will trigger a redraw to update the table
       minEl.on('input', function () {
           JSTable.draw();
       });
       maxEl.on('input', function () {
           JSTable.draw();
       });

       minRsiEl.on('input', function () {
           JSTable.draw();
       });
       maxRsiEl.on('input', function () {
           JSTable.draw();
       });

       minNumberEl.on('input', function () {
           JSTable.draw();
       });
       maxNumberEl.on('input', function () {
           JSTable.draw();
       });




       // Merouane Age Filter END


      tableScrollX();

      $(window).resize(function() {
        tableScrollX();
      });




   });


function tableScrollX() {

  if (dcurrency == "EUR") {
    $('body').addClass('EUR');
  } else {
    $('body').removeClass('EUR');
  }

  tableWidth = $('table#crypto-table').width();
  tablePrtWidth = $('div#crypto-table_wrapper').width();

  if (tableWidth > tablePrtWidth) {
    $('body').addClass('scrollx-active');
    $('body').addClass('scrollx-initial');
  } else {
    $('body').removeClass('scrollx-active');
    $('body').removeClass('scrollx-initial');
  }

  $('#list-view').scroll(function (event) {
    tableLeft = $(this).scrollLeft();
    // console.log(tableLeft);
    if (tableLeft < 20) {
      $('body').addClass('scrollx-initial')
      $('body').removeClass('scrollx-middle');
      $('body').removeClass('scrollx-bottom');
    } else if ((tableLeft + tablePrtWidth) < (tableWidth - 20)) {
      $('body').removeClass('scrollx-initial');
      $('body').addClass('scrollx-middle');
      $('body').removeClass('scrollx-bottom');
    } else {
      $('body').removeClass('scrollx-initial');
      $('body').removeClass('scrollx-middle');
      $('body').addClass('scrollx-bottom');
    }
    $('#list-view:not(.grid-view) #wl-nresult').css("transform", "translateX("+tableLeft+"px)");
    $('#list-view:not(.grid-view) .processing_overlay').css("transform", "translateX("+tableLeft+"px)");
});


    $("#tableScBtnR").single_double_click(function () {
      var scrollLeftThR = $('#list-view').scrollLeft();
      $("#list-view").scrollLeft( scrollLeftThR+220 )
    }, function () {
      $("#list-view").scrollLeft( 4000 )
    })

    $("#tableScBtnL").single_double_click(function () {
      var scrollLeftThR = $('#list-view').scrollLeft();
      $("#list-view").scrollLeft( scrollLeftThR-220 )
    }, function () {
      $("#list-view").scrollLeft( 0 )
    })


}

jQuery.fn.single_double_click = function(single_click_callback, double_click_callback, timeout) {
  return this.each(function(){
    var clicks = 0, self = this;
    jQuery(this).click(function(event){
      clicks++;
      if (clicks == 1) {
        setTimeout(function(){
          if(clicks == 1) {
            single_click_callback.call(self, event);
          } else {
            double_click_callback.call(self, event);
          }
          clicks = 0;
        }, timeout || 200);
      }
    });
  });
}

  
  !function(e){"function"==typeof define&&define.amd?define(e):e()}(function(){var e,t=["scroll","wheel","touchstart","touchmove","touchenter","touchend","touchleave","mouseout","mouseleave","mouseup","mousedown","mousemove","mouseenter","mousewheel","mouseover"];if(function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}()){var n=EventTarget.prototype.addEventListener;e=n,EventTarget.prototype.addEventListener=function(n,o,r){var i,s="object"==typeof r&&null!==r,u=s?r.capture:r;(r=s?function(e){var t=Object.getOwnPropertyDescriptor(e,"passive");return t&&!0!==t.writable&&void 0===t.set?Object.assign({},e):e}(r):{}).passive=void 0!==(i=r.passive)?i:-1!==t.indexOf(n)&&!0,r.capture=void 0!==u&&u,e.call(this,n,o,r)},EventTarget.prototype.addEventListener._original=e}});
